var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _path29, _path30, _path31, _path32, _circle2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _circle3, _circle4, _path53, _path54, _path55, _path56, _circle5, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _circle6, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _circle7, _path161, _path162, _path163, _path164, _circle8, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _circle9, _path187, _path188, _path189, _circle10, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _circle11, _path228, _path229, _path230, _path231, _circle12, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _circle13, _path253, _path254, _path255, _path256, _circle14, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarksCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.2,38.23a3.89,3.89,0,0,0-1.1-.21,90.86,90.86,0,0,0-47.49.21L66.54,39v78.58l5.25-1.43a84.42,84.42,0,0,1,41.15-.76c1,.22,2.08.44,3.07.76l1.09.33,1.1-.33a28.33,28.33,0,0,1,3-.65V39Zm-5.26,68.84a89.74,89.74,0,0,0-38.19,0V45.35a83.23,83.23,0,0,1,38.19,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,38.23A90.9,90.9,0,0,0,117.1,38a3.82,3.82,0,0,0-1.09.21l-3.07.77v76.39c1,.22,2.08.44,3.07.76l1.09.33,1.1-.33a28.33,28.33,0,0,1,3-.65,82.28,82.28,0,0,1,41.26.65l5.14,1.43V39Zm-5.25,68.84a86.26,86.26,0,0,0-19-2.08,87.21,87.21,0,0,0-19.15,2.08V45.35a83.27,83.27,0,0,1,38.2,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 296.56,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.96,
    y: 310.67,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 310.67,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.79,
    y: 310.67,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.79,
    y: 67.07,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.56,
    y: 81.18,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.96,
    y: 67.08,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.4,
    y: 162.83,
    width: 26.48,
    height: 11.19,
    transform: "translate(421.29 336.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.18,
    y: 125.69,
    width: 26.48,
    height: 11.19,
    transform: "translate(450.83 262.58) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-105"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.57,
    cy: 456.87,
    rx: 193.31,
    ry: 11.43,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-105"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.12 428.81 91.84 428.57 144.56 428.48 250 428.32 355.44 428.48 408.16 428.57 460.88 428.81 408.16 429.06 355.44 429.15 250 429.31 144.56 429.15 91.84 429.06 39.12 428.81",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.05,101.41V412.89c0,8.8-6.59,15.92-14.72,15.92H266c-8.15,0-14.75-7.12-14.75-15.92V101.41c0-17.94,6.6-18.81,14.75-18.81h29.11c1.69,0,3.08,1.92,3.08,4.3v1c0,5.59,3.05,5.61,6.81,5.61H372.3c3.79,0,6.82,0,6.82-5.61v-1c0-2.38,1.36-4.3,3.08-4.3h29.13C419.46,82.6,426.05,85,426.05,101.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.33,429.19H266c-8.34,0-15.12-7.31-15.12-16.3V101.41c0-17.81,6.26-19.19,15.12-19.19h29.11c1.9,0,3.45,2.1,3.45,4.68v1c0,5.23,2.7,5.23,6.44,5.23H372.3c3.74,0,6.44,0,6.44-5.23v-1c0-2.62,1.52-4.68,3.46-4.68h29.13c9.06,0,15.1,3.26,15.1,19.19V412.89C426.43,421.88,419.65,429.19,411.33,429.19ZM266,83c-8.42,0-14.37,1.32-14.37,18.44V412.89c0,8.57,6.44,15.55,14.37,15.55H411.33c7.91,0,14.35-7,14.35-15.55V101.41c0-15.35-5.49-18.44-14.35-18.44H382.2c-1.49,0-2.71,1.77-2.71,3.93v1c0,6-3.49,6-7.19,6H305c-3.7,0-7.19,0-7.19-6v-1c0-2.16-1.21-3.93-2.7-3.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.05,101.41v23.24H251.21V101.41c0-17.94,6.59-18.81,14.74-18.81H411.32C419.45,82.6,426.05,85,426.05,101.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.05,89.59l-.28.28-.16.16a3.84,3.84,0,0,0-5.43,0l-.15-.16a3.7,3.7,0,0,0-.28-.28h0l0,0,.35-.32a4.37,4.37,0,0,1,.82-.52,4.25,4.25,0,0,1,1.09-.37l.55-.07h.48l.37,0a4.41,4.41,0,0,1,1,.24,4.44,4.44,0,0,1,1.32.77l.3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,90.92l-.45-.44a3.11,3.11,0,0,1,1.81-.91,3.17,3.17,0,0,1,2.72.9l-.45.44a2.56,2.56,0,0,0-3.63,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.27,91.36l-.44.44a1.34,1.34,0,0,0-1.87,0l-.44-.44A1.94,1.94,0,0,1,288.27,91.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,92.2a.4.4,0,1,1-.8,0,.4.4,0,0,1,.8,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.61,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,262.61,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.26,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,266.26,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.91,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,269.91,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.56,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,273.56,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.21,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,277.21,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.94,93h-9.45V88.59h9.45Zm-8.95-.5h8.45V89.09H404Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.28,
    y: 89.35,
    width: 6.08,
    height: 2.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.94,
    y: 89.62,
    width: 0.84,
    height: 2.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.03 391.18 404.18 391.36 382.32 391.43 338.62 391.55 294.92 391.43 273.07 391.36 251.22 391.18 273.07 391 294.92 390.93 338.62 390.81 382.32 390.93 404.18 391 426.03 391.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.79 412.27 270.51 409.2 273.79 406.13 274.29 406.67 271.6 409.2 274.29 411.73 273.79 412.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.95 406.13 307.23 409.2 303.95 412.27 303.45 411.73 306.14 409.2 303.45 406.67 303.95 406.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.66 414.31 335.89 414.31 335.89 407.54 338.1 407.54 338.1 408.29 336.64 408.29 336.64 413.56 341.91 413.56 341.91 408.29 340.46 408.29 340.46 407.54 342.66 407.54 342.66 414.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.88,
    y: 404.46,
    width: 0.75,
    height: 6.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.98 406.82 339.28 405 337.57 406.82 337.02 406.31 339.28 403.91 341.53 406.31 340.98 406.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81,405.47l-.11,0a8.84,8.84,0,0,0-4.65,0l-.3.08v7.69l.51-.14a8.33,8.33,0,0,1,4-.07l.3.07.11,0,.11,0c.1,0,.19-.05.29-.06v-7.49Zm-.52,6.74a9.06,9.06,0,0,0-3.74,0v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.35,405.47a8.84,8.84,0,0,0-4.65,0l-.11,0-.3.08V413l.3.07.11,0,.11,0c.1,0,.19-.05.29-.06a8.13,8.13,0,0,1,4,.06l.5.14v-7.69Zm-.51,6.74a8.84,8.84,0,0,0-3.74,0v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.09 411.55 398.79 411.55 398.79 405.16 405.18 405.16 405.18 407.22 404.43 407.22 404.43 405.91 399.54 405.91 399.54 410.8 401.09 410.8 401.09 411.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.11,413.23h-6.39v-6.39h6.39Zm-5.64-.75h4.89v-4.89h-4.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.88,295a16.92,16.92,0,0,1-4.61,4.67,16.68,16.68,0,0,1-4.59-4.67c-1.53-2.81-.69-5.68,1.51-5.68,2.45,0,3.08,3.06,3.08,3.06s.65-3.06,3.09-3.06C393.56,289.34,394.41,292.21,392.88,295Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.86,
    y: 143.86,
    width: 12.59,
    height: 2.07,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.86,
    y: 148.01,
    width: 12.59,
    height: 2.07,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.86,
    y: 152.15,
    width: 12.59,
    height: 2.07,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.56,
    y: 147.39,
    width: 1.73,
    height: 7.01,
    transform: "translate(-16.16 253.71) rotate(-37.15)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.51,145.21a3.77,3.77,0,1,1-5.29-.7A3.78,3.78,0,0,1,369.51,145.21Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,146.13a2.26,2.26,0,1,1-3.17-.41A2.27,2.27,0,0,1,368.31,146.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,149.54a16.86,16.86,0,0,1-4.61,4.68,16.74,16.74,0,0,1-4.6-4.68c-1.52-2.8-.68-5.68,1.52-5.68,2.45,0,3.08,3.06,3.08,3.06s.64-3.06,3.09-3.06C389.25,143.86,390.1,146.74,388.58,149.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,152.14h-7.6l-1.91-7.7h-.76v-.65h1.27l.38,1.52H405Zm-7.09-.65h6.6l1.52-5.52H394.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.93 153.38 401.4 152.13 397.09 152.13 396.67 153.36 396.06 153.15 396.63 151.48 401.84 151.48 402.53 153.13 401.93 153.38",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.66,
    y: 146.82,
    width: 9.49,
    height: 0.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.13,
    y: 144.47,
    width: 0.65,
    height: 8.58,
    transform: "translate(248.92 547.56) rotate(-89.75)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.52,
    y: 150.09,
    width: 7.78,
    height: 0.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.98,
    y: 145.67,
    width: 0.65,
    height: 6.14,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.66,
    y: 148.42,
    width: 6.16,
    height: 0.65,
    transform: "translate(220.68 536.42) rotate(-85.45)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.15,
    y: 148.42,
    width: 6.24,
    height: 0.65,
    transform: "translate(183.2 517.46) rotate(-79.58)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.58,
    y: 145.66,
    width: 0.65,
    height: 6.16,
    transform: "translate(-10.61 32.26) rotate(-4.58)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.04,
    y: 145.62,
    width: 0.65,
    height: 6.24,
    transform: "translate(-20.37 74.15) rotate(-10.42)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.23,154.29a1,1,0,1,1,1-1A1,1,0,0,1,402.23,154.29Zm0-1.43a.4.4,0,0,0-.39.39.39.39,0,1,0,.78,0A.4.4,0,0,0,402.23,152.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.38,154.29a1,1,0,1,1,1-1A1,1,0,0,1,396.38,154.29Zm0-1.43a.39.39,0,0,0-.38.39.39.39,0,1,0,.77,0A.39.39,0,0,0,396.38,152.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.4,143.63a2.78,2.78,0,1,1-2.78-2.78A2.78,2.78,0,0,1,407.4,143.63Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,142v3.08a.28.28,0,0,1-.29.28.27.27,0,0,1-.28-.28v-2.57l-.21.12a.28.28,0,0,1-.15,0,.29.29,0,0,1-.15-.53l.64-.38h0l0,0h0s0,0,0,0h.2s0,0,0,0h0l0,0,0,0,0,0h0v0s0,0,0,0v0s0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.6,
    y: 291.39,
    width: 69.18,
    height: 1.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.6,
    y: 295.04,
    width: 59.5,
    height: 1.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.66 232.21 273.88 229.6 276.66 227 277.09 227.46 274.8 229.6 277.09 231.75 276.66 232.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.09,234.24a4.64,4.64,0,1,1,4.64-4.64A4.64,4.64,0,0,1,276.09,234.24Zm0-8.44a3.8,3.8,0,1,0,3.8,3.8A3.81,3.81,0,0,0,276.09,225.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.6 232.21 400.17 231.75 402.45 229.6 400.17 227.46 400.6 227 403.38 229.6 400.6 232.21",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.16,234.24a4.64,4.64,0,1,1,4.64-4.64A4.64,4.64,0,0,1,401.16,234.24Zm0-8.44a3.8,3.8,0,1,0,3.8,3.8A3.8,3.8,0,0,0,401.16,225.8Z",
    style: {
      fill: "#c7c7c7"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288,341.51a.25.25,0,0,1,.25.25v.41a3.49,3.49,0,0,1,1.86.73c.09.08.15.14.15.24a.27.27,0,0,1-.28.26.24.24,0,0,1-.18-.07,3,3,0,0,0-1.57-.68v2.92c1.59.34,2.26.93,2.26,1.95a2.06,2.06,0,0,1-2.24,1.93v.81a.25.25,0,0,1-.25.25.25.25,0,0,1-.25-.25v-.82a3.93,3.93,0,0,1-2.34-1,.26.26,0,0,1-.12-.22.27.27,0,0,1,.26-.26.26.26,0,0,1,.19.07,3.38,3.38,0,0,0,2,1v-3c-1.56-.34-2.21-.92-2.21-2a2,2,0,0,1,2.19-1.89v-.39A.25.25,0,0,1,288,341.51Zm-.23,4v-2.85a1.51,1.51,0,0,0-1.67,1.38C286.06,344.71,286.39,345.14,287.73,345.47Zm.46.63V349c1.05,0,1.72-.62,1.72-1.42S289.55,346.41,288.19,346.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M291.77,349l3.41-3.07a1.89,1.89,0,0,0,.62-1.4,1.81,1.81,0,0,0-.49-1.25,1.83,1.83,0,0,0-1.38-.62,1.9,1.9,0,0,0-1.27.48l-.36.33a.24.24,0,0,1-.35,0,.24.24,0,0,1,0-.36l.35-.33a2.43,2.43,0,0,1,1.62-.62,2.38,2.38,0,0,1,2.37,2.38,2.39,2.39,0,0,1-.78,1.77l-2.92,2.64h3.45a.26.26,0,0,1,0,.51H292a.24.24,0,0,1-.19-.07A.29.29,0,0,1,291.77,349Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298,345.8a4.6,4.6,0,0,1,.69-2.55,2.06,2.06,0,0,1,3.65,0,4.93,4.93,0,0,1,0,5.1,2.06,2.06,0,0,1-3.65,0A4.6,4.6,0,0,1,298,345.8Zm.51,0a4.16,4.16,0,0,0,.61,2.26,1.55,1.55,0,0,0,2.8,0,4.43,4.43,0,0,0,0-4.52,1.55,1.55,0,0,0-2.8,0A4.18,4.18,0,0,0,298.55,345.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.93,348.41a.52.52,0,1,1-.52.52A.52.52,0,0,1,305.93,348.41Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M307.42,345.8a4.6,4.6,0,0,1,.7-2.55,2.06,2.06,0,0,1,3.65,0,5,5,0,0,1,0,5.1,2.06,2.06,0,0,1-3.65,0A4.6,4.6,0,0,1,307.42,345.8Zm.51,0a4.16,4.16,0,0,0,.61,2.26,1.55,1.55,0,0,0,2.8,0,4.43,4.43,0,0,0,0-4.52,1.55,1.55,0,0,0-2.8,0A4.18,4.18,0,0,0,307.93,345.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,345.8a4.6,4.6,0,0,1,.7-2.55,2.06,2.06,0,0,1,3.65,0,4.93,4.93,0,0,1,0,5.1,2.06,2.06,0,0,1-3.65,0A4.6,4.6,0,0,1,314.82,345.8Zm.51,0a4.08,4.08,0,0,0,.62,2.26,1.73,1.73,0,0,0,1.39.88,1.75,1.75,0,0,0,1.4-.88,4.37,4.37,0,0,0,0-4.52,1.73,1.73,0,0,0-1.4-.88,1.7,1.7,0,0,0-1.39.88A4.1,4.1,0,0,0,315.33,345.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.08,166.53l-1.56,2.16a.16.16,0,0,1-.14.08h0a.15.15,0,0,1-.15-.08l-1.56-2.15v4a.16.16,0,0,1-.17.16.17.17,0,0,1-.17-.16V166a.17.17,0,0,1,.07-.13s0,0,0,0a.19.19,0,0,1,.24.05l1.73,2.4,1.73-2.4a.17.17,0,0,1,.23-.05l.05.06a.16.16,0,0,1,0,.09v4.51a.17.17,0,0,1-.17.16.16.16,0,0,1-.16-.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.56,167.3A1.7,1.7,0,1,1,290,169,1.67,1.67,0,0,1,291.56,167.3Zm0,3.07a1.38,1.38,0,0,0,0-2.75,1.38,1.38,0,0,0,0,2.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.18,170a1.6,1.6,0,0,1-1.31.66,1.7,1.7,0,0,1,0-3.4,1.63,1.63,0,0,1,1.31.66v-2a.17.17,0,0,1,.18-.16.16.16,0,0,1,.16.16v4.54a.16.16,0,0,1-.16.16.17.17,0,0,1-.18-.16Zm0-1V169a1.36,1.36,0,1,0,0,.11Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M298.69,169a1.68,1.68,0,0,1,1.66-1.71,1.66,1.66,0,0,1,1.64,1.58h0v0a.15.15,0,0,1-.17.15H299a1.34,1.34,0,0,0,1.32,1.31,1.29,1.29,0,0,0,1.1-.62.15.15,0,0,1,.22-.05.17.17,0,0,1,.06.23,1.61,1.61,0,0,1-1.38.77A1.68,1.68,0,0,1,298.69,169Zm.36-.27h2.58a1.32,1.32,0,0,0-1.28-1.11A1.33,1.33,0,0,0,299.05,168.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303,167.47a.17.17,0,0,1,.18-.17.17.17,0,0,1,.16.17v.75a.35.35,0,0,1,.05-.08,1.64,1.64,0,0,1,1.36-.84.17.17,0,0,1,.17.17.18.18,0,0,1-.17.17,1.26,1.26,0,0,0-1,.55,3.15,3.15,0,0,0-.41.8.11.11,0,0,0,0,0v1.5a.16.16,0,0,1-.16.16.16.16,0,0,1-.18-.16Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51,168.69a1,1,0,0,0-1.05-1.05,1.07,1.07,0,0,0-1.06,1.05v1.88a.11.11,0,0,1,0,.07.16.16,0,0,1-.13.06h0a.14.14,0,0,1-.11-.09s0,0,0,0h0v-3.11a.16.16,0,1,1,.32,0v.33a1.38,1.38,0,0,1,2.44.89v1.85a.15.15,0,0,1-.16.16.16.16,0,0,1-.17-.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.34,168.44h-2.5v2.1a.17.17,0,0,1-.34,0V166a.17.17,0,0,1,.34,0v2.1h2.5V166a.17.17,0,0,1,.17-.16.16.16,0,0,1,.17.16v4.54a.16.16,0,0,1-.17.16.17.17,0,0,1-.17-.16Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M320.21,167.46v3.08a.17.17,0,0,1-.34,0V170a1.58,1.58,0,0,1-1.27.67,1.7,1.7,0,0,1,0-3.4,1.57,1.57,0,0,1,1.27.66v-.5a.17.17,0,0,1,.34,0Zm-.34,1.54a1.28,1.28,0,1,0-1.27,1.37A1.32,1.32,0,0,0,319.87,169Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324,168.69a1,1,0,0,0-1-1.05,1.06,1.06,0,0,0-1.06,1.05v1.88s0,.05,0,.07a.16.16,0,0,1-.13.06h0a.14.14,0,0,1-.11-.09s0,0,0,0h0v-3.11a.17.17,0,0,1,.17-.17.17.17,0,0,1,.16.17v.33a1.38,1.38,0,0,1,2.44.89v1.85a.16.16,0,0,1-.17.16.15.15,0,0,1-.16-.16Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M328.43,170a1.6,1.6,0,0,1-1.31.66,1.7,1.7,0,0,1,0-3.4,1.63,1.63,0,0,1,1.31.66v-2a.17.17,0,0,1,.18-.16.16.16,0,0,1,.16.16v4.54a.16.16,0,0,1-.16.16.17.17,0,0,1-.18-.16Zm0-1V169a1.36,1.36,0,1,0,0,.11Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M330.29,169.08V166a.17.17,0,0,1,.17-.16.16.16,0,0,1,.17.16v2a1.64,1.64,0,0,1,1.31-.66,1.7,1.7,0,0,1,0,3.4,1.62,1.62,0,0,1-1.31-.66v.5a.16.16,0,0,1-.17.16.17.17,0,0,1-.17-.16Zm.34-.07a1.34,1.34,0,1,0,0-.06Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M337.74,167.46v3.08a.17.17,0,0,1-.34,0V170a1.58,1.58,0,0,1-1.28.67,1.7,1.7,0,0,1,0-3.4,1.57,1.57,0,0,1,1.28.66v-.5a.17.17,0,0,1,.34,0ZM337.4,169a1.28,1.28,0,1,0-1.28,1.37A1.32,1.32,0,0,0,337.4,169Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4,170.43a1.59,1.59,0,0,1-1.61,1.6,1.67,1.67,0,0,1-.7-.16.17.17,0,0,1-.07-.22.16.16,0,0,1,.22-.08,1.14,1.14,0,0,0,.55.13,1.27,1.27,0,0,0,1.28-1.27V170a1.55,1.55,0,0,1-1.28.66,1.69,1.69,0,0,1,0-3.38,1.57,1.57,0,0,1,1.28.66v-.5a.16.16,0,0,1,.17-.16.16.16,0,0,1,.16.16Zm-.33-1.44a1.27,1.27,0,1,0-1.28,1.37A1.31,1.31,0,0,0,342.07,169Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.64,302.76a2.54,2.54,0,0,1,1.57.53.18.18,0,0,1-.21.28,2.24,2.24,0,0,0-1.36-.47,2.13,2.13,0,1,0,0,4.25,2.07,2.07,0,0,0,1.35-.47.16.16,0,0,1,.24,0,.16.16,0,0,1,0,.24,2.54,2.54,0,0,1-1.57.53,2.47,2.47,0,1,1,0-4.93Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M291,304.29a1.7,1.7,0,0,1,0,3.4,1.7,1.7,0,0,1,0-3.4Zm0,3.07a1.38,1.38,0,1,0-1.28-1.37A1.34,1.34,0,0,0,291,307.36Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M293.93,303a.17.17,0,0,1,.16-.17.18.18,0,0,1,.18.17v4.54a.17.17,0,0,1-.18.16.16.16,0,0,1-.16-.16Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M297.06,304.29a1.7,1.7,0,1,1-1.61,1.7A1.66,1.66,0,0,1,297.06,304.29Zm0,3.07a1.38,1.38,0,0,0,0-2.75,1.38,1.38,0,0,0,0,2.75Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M299.81,304.46a.17.17,0,0,1,.18-.17.17.17,0,0,1,.16.17v.75a.22.22,0,0,1,.05-.08,1.62,1.62,0,0,1,1.36-.84.17.17,0,0,1,.17.17.18.18,0,0,1-.17.17,1.24,1.24,0,0,0-1,.55,3.15,3.15,0,0,0-.41.8.11.11,0,0,0,0,0v1.5a.16.16,0,0,1-.16.16.17.17,0,0,1-.18-.16Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 292.44,
    y: 360.38,
    width: 92.37,
    height: 19.45,
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.24,372.41H305.7l-.51,1.36a.57.57,0,0,1-.54.36.69.69,0,0,1-.2,0,.58.58,0,0,1-.34-.75l2.3-6.14a.59.59,0,0,1,.56-.36.57.57,0,0,1,.55.36l2.3,6.14a.58.58,0,0,1-.34.75.6.6,0,0,1-.2,0,.55.55,0,0,1-.53-.36Zm-.43-1.14L307,369l-.85,2.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.25,373.56v-6.15a.56.56,0,0,1,.57-.57h1.23a3.65,3.65,0,0,1,0,7.29h-1.23A.57.57,0,0,1,311.25,373.56Zm1.16-.58h.64a2.5,2.5,0,0,0,0-5h-.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.43,373.56v-6.15a.57.57,0,0,1,.58-.57h1.23a3.65,3.65,0,0,1,0,7.29H319A.57.57,0,0,1,318.43,373.56Zm1.16-.58h.65a2.5,2.5,0,0,0,0-5h-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,368h-1.66v5.57a.56.56,0,0,1-.57.57.57.57,0,0,1-.57-.57V368h-1.65a.58.58,0,0,1-.58-.58.57.57,0,0,1,.58-.57h4.45a.57.57,0,0,1,.57.57A.59.59,0,0,1,333.52,368Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,367.74a3.82,3.82,0,0,1,0,5.28,3.39,3.39,0,0,1-2.49,1.11A3.49,3.49,0,0,1,336,373a3.9,3.9,0,0,1,0-5.28,3.45,3.45,0,0,1,2.55-1.11A3.35,3.35,0,0,1,341,367.74Zm-.13,2.64a2.66,2.66,0,0,0-.71-1.82,2.25,2.25,0,0,0-1.65-.74,2.28,2.28,0,0,0-1.69.74,2.66,2.66,0,0,0-.71,1.82,2.62,2.62,0,0,0,.71,1.81,2.3,2.3,0,0,0,1.69.76,2.27,2.27,0,0,0,1.65-.76A2.62,2.62,0,0,0,340.86,370.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.91,370.38a3.83,3.83,0,0,1,3.82-3.75,3.89,3.89,0,0,1,2.41.81.62.62,0,0,1,.11.83.61.61,0,0,1-.84.12,2.57,2.57,0,0,0-1.68-.57,2.74,2.74,0,0,0-1.87.75,2.57,2.57,0,0,0-.77,1.81,2.51,2.51,0,0,0,.77,1.81,2.74,2.74,0,0,0,1.87.76,2.6,2.6,0,0,0,1.68-.58.64.64,0,0,1,.84.12.62.62,0,0,1-.11.83,3.89,3.89,0,0,1-2.41.81A3.81,3.81,0,0,1,346.91,370.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.83,372.41H356.3l-.51,1.36a.57.57,0,0,1-.54.36.57.57,0,0,1-.55-.78l2.31-6.14a.57.57,0,0,1,.55-.36.56.56,0,0,1,.55.36l2.31,6.14a.59.59,0,0,1-.35.75.54.54,0,0,1-.19,0,.57.57,0,0,1-.54-.36Zm-.42-1.14-.85-2.24-.84,2.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.67,373.27a.57.57,0,0,1-.36.73,1,1,0,0,1-.23,0h0a.81.81,0,0,1-.41-.11,1.07,1.07,0,0,1-.33-.37,2.74,2.74,0,0,1-.22-1.25.93.93,0,0,0-.12-.45,1,1,0,0,0-.32-.3,1.89,1.89,0,0,0-.58-.25h-1.23v2.26a.58.58,0,0,1-.59.57.57.57,0,0,1-.57-.57v-6.15a.56.56,0,0,1,.57-.57h1.87a2.23,2.23,0,0,1,1.42,4,1.64,1.64,0,0,1,.36.38,2,2,0,0,1,.35,1.13,2.68,2.68,0,0,0,0,.61A.56.56,0,0,1,366.67,373.27Zm-1.46-4.19a1.08,1.08,0,0,0-1.07-1.09h-1.28v2.15h1.28A1.07,1.07,0,0,0,365.21,369.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.62,368H371v5.57a.56.56,0,0,1-.57.57.57.57,0,0,1-.58-.57V368h-1.65a.58.58,0,0,1-.57-.58.56.56,0,0,1,.57-.57h4.46a.57.57,0,0,1,.57.57A.59.59,0,0,1,372.62,368Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.6,
    y: 174.58,
    width: 110.06,
    height: 110.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.89,272.3c0,3.47-20.26,6.28-45.26,6.28s-45.27-2.81-45.27-6.28S313.63,266,338.63,266,383.89,268.83,383.89,272.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1,271.92h-55c-14.85,0-12.47-11.88-8.9-24.35s8.84-31.37,22.11-31.37H352.9c13.27,0,18.55,18.9,22.11,31.37S381,271.92,366.1,271.92Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,216.8a.57.57,0,1,1-.56-.56A.56.56,0,0,1,322.8,216.8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M332.17,216.8a.56.56,0,0,1-.57.57.57.57,0,1,1,0-1.13A.56.56,0,0,1,332.17,216.8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M341.54,216.8a.57.57,0,1,1-.57-.56A.57.57,0,0,1,341.54,216.8Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,216.8a.57.57,0,1,1-.56-.56A.56.56,0,0,1,350.9,216.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 312.87,
    cy: 228.84,
    r: 0.57
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,228.84a.57.57,0,1,1-.56-.56A.56.56,0,0,1,322.8,228.84Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M332.17,228.84a.56.56,0,0,1-.57.57.57.57,0,1,1,0-1.13A.56.56,0,0,1,332.17,228.84Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M341.54,228.84a.57.57,0,1,1-.57-.56A.57.57,0,0,1,341.54,228.84Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,228.84a.57.57,0,1,1-.56-.56A.56.56,0,0,1,350.9,228.84Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.7,
    cy: 228.84,
    r: 0.57
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12,222.67a.57.57,0,1,1-.57-.57A.57.57,0,0,1,318.12,222.67Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49,222.67a.57.57,0,1,1-.57-.57A.58.58,0,0,1,327.49,222.67Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,222.67a.57.57,0,1,1-.56-.57A.57.57,0,0,1,336.85,222.67Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22,222.67a.57.57,0,0,1-.57.57.57.57,0,1,1,0-1.14A.57.57,0,0,1,346.22,222.67Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M355.59,222.67a.57.57,0,1,1-.57-.57A.58.58,0,0,1,355.59,222.67Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M364.87,223a.54.54,0,0,1-.49.29.56.56,0,0,1-.56-.57.55.55,0,0,1,.39-.54C364.44,222.4,364.65,222.67,364.87,223Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M313.44,240.88a.57.57,0,0,1-1.14,0,.57.57,0,0,1,1.14,0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,240.88a.57.57,0,1,1-1.13,0,.57.57,0,1,1,1.13,0Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.17,240.88a.56.56,0,0,1-.57.57.57.57,0,0,1-.57-.57.58.58,0,0,1,.57-.57A.57.57,0,0,1,332.17,240.88Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M341.54,240.88a.57.57,0,0,1-1.14,0,.57.57,0,1,1,1.14,0Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,240.88a.57.57,0,1,1-1.13,0,.57.57,0,1,1,1.13,0Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M360.27,240.88a.56.56,0,0,1-.57.57.57.57,0,0,1-.57-.57.58.58,0,0,1,.57-.57A.57.57,0,0,1,360.27,240.88Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M369.64,240.88a.57.57,0,0,1-.57.57.56.56,0,0,1-.57-.57.57.57,0,0,1,.57-.57A.58.58,0,0,1,369.64,240.88Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75,234.71a.57.57,0,1,1-.56-.57A.57.57,0,0,1,308.75,234.71Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12,234.71a.57.57,0,1,1-.57-.57A.57.57,0,0,1,318.12,234.71Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49,234.71a.57.57,0,1,1-.57-.57A.58.58,0,0,1,327.49,234.71Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,234.71a.57.57,0,1,1-.56-.57A.57.57,0,0,1,336.85,234.71Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22,234.71a.57.57,0,0,1-.57.57.57.57,0,0,1,0-1.14A.57.57,0,0,1,346.22,234.71Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M355.59,234.71a.57.57,0,1,1-.57-.57A.58.58,0,0,1,355.59,234.71Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M365,234.71a.57.57,0,1,1-.56-.57A.57.57,0,0,1,365,234.71Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.5,
    cy: 252.92,
    r: 0.57
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.87,
    cy: 252.92,
    r: 0.57
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,252.92a.57.57,0,1,1-.56-.57A.57.57,0,0,1,322.8,252.92Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M332.17,252.92a.57.57,0,0,1-.57.57.57.57,0,0,1,0-1.14A.57.57,0,0,1,332.17,252.92Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M341.54,252.92a.57.57,0,1,1-.57-.57A.58.58,0,0,1,341.54,252.92Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,252.92a.57.57,0,1,1-.56-.57A.57.57,0,0,1,350.9,252.92Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.7,
    cy: 252.92,
    r: 0.57
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M369.64,252.92a.58.58,0,0,1-.57.57.57.57,0,1,1,0-1.14A.58.58,0,0,1,369.64,252.92Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75,246.75a.57.57,0,1,1-.56-.57A.56.56,0,0,1,308.75,246.75Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12,246.75a.57.57,0,1,1-1.13,0,.57.57,0,1,1,1.13,0Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49,246.75a.57.57,0,0,1-1.14,0,.57.57,0,0,1,1.14,0Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,246.75a.57.57,0,1,1-.56-.57A.56.56,0,0,1,336.85,246.75Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22,246.75a.57.57,0,0,1-.57.57.58.58,0,0,1-.57-.57.57.57,0,0,1,.57-.57A.56.56,0,0,1,346.22,246.75Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M355.59,246.75a.57.57,0,0,1-1.14,0,.57.57,0,0,1,1.14,0Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M365,246.75a.57.57,0,1,1-.56-.57A.56.56,0,0,1,365,246.75Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.75,
    cy: 246.75,
    r: 0.57
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M304.07,265a.57.57,0,1,1-.57-.57A.57.57,0,0,1,304.07,265Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M313.44,265a.57.57,0,1,1-.57-.57A.58.58,0,0,1,313.44,265Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M322.8,265a.57.57,0,1,1-.56-.57A.57.57,0,0,1,322.8,265Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M332.17,265a.57.57,0,0,1-.57.57.57.57,0,1,1,0-1.14A.57.57,0,0,1,332.17,265Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M341.54,265a.57.57,0,1,1-.57-.57A.58.58,0,0,1,341.54,265Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M350.9,265a.57.57,0,1,1-.56-.57A.57.57,0,0,1,350.9,265Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M360.27,265a.57.57,0,0,1-.57.57.57.57,0,0,1,0-1.14A.57.57,0,0,1,360.27,265Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M369.64,265a.58.58,0,0,1-.57.57.57.57,0,0,1,0-1.14A.58.58,0,0,1,369.64,265Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75,258.79a.57.57,0,1,1-.56-.57A.56.56,0,0,1,308.75,258.79Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12,258.79a.57.57,0,1,1-.57-.57A.56.56,0,0,1,318.12,258.79Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49,258.79a.57.57,0,1,1-.57-.57A.57.57,0,0,1,327.49,258.79Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,258.79a.57.57,0,1,1-.56-.57A.56.56,0,0,1,336.85,258.79Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22,258.79a.56.56,0,0,1-.57.56.57.57,0,1,1,.57-.56Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M355.59,258.79a.57.57,0,1,1-.57-.57A.57.57,0,0,1,355.59,258.79Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M365,258.79a.57.57,0,1,1-.56-.57A.56.56,0,0,1,365,258.79Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M374.32,258.79a.56.56,0,0,1-.57.56.57.57,0,1,1,.57-.56Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M308.75,270.83a.57.57,0,1,1-.56-.57A.56.56,0,0,1,308.75,270.83Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M318.12,270.83a.57.57,0,1,1-.57-.57A.56.56,0,0,1,318.12,270.83Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M327.49,270.83a.57.57,0,1,1-.57-.57A.57.57,0,0,1,327.49,270.83Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M336.85,270.83a.57.57,0,1,1-.56-.57A.56.56,0,0,1,336.85,270.83Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22,270.83a.56.56,0,0,1-.57.56.57.57,0,1,1,.57-.56Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M355.59,270.83a.57.57,0,1,1-.57-.57A.57.57,0,0,1,355.59,270.83Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M365,270.83a.57.57,0,1,1-.56-.57A.56.56,0,0,1,365,270.83Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M373.64,270.27a1.34,1.34,0,0,1-.31.17A.59.59,0,0,1,373.64,270.27Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 323.44,
    cy: 222.76,
    r: 4.55,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.81,
    cy: 222.76,
    r: 4.55,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53,222.76a3.09,3.09,0,1,1-3.09-3.08A3.09,3.09,0,0,1,326.53,222.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.9,222.76a3.09,3.09,0,1,1-3.09-3.08A3.09,3.09,0,0,1,356.9,222.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.81,223.43a1.74,1.74,0,0,1-1.74-1.74,86.18,86.18,0,0,0-2.59-16.37c-1.75-6.51-5-14.27-10.44-14.27-10.09,0-13.86,25.44-13.86,30.64a1.74,1.74,0,0,1-3.48,0c0-.34,2.11-34.12,17.34-34.12,14.76,0,16.51,33.78,16.51,34.12A1.74,1.74,0,0,1,353.81,223.43Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.6,
    y: 312.49,
    width: 19.61,
    height: 19.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.3,329.83h-9.79c-2.65,0-2.22-2.11-1.59-4.33s1.58-5.59,3.94-5.59H296c2.36,0,3.3,3.36,3.94,5.59S301,329.83,298.3,329.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,320a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,290.58,320Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M292.25,320a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,292.25,320Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,320a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,293.92,320Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M295.59,320a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,295.59,320Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M288.92,322.16a.11.11,0,0,1-.11.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.1.1,0,0,1,288.92,322.16Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,322.16a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,290.58,322.16Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M292.25,322.16a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,292.25,322.16Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,322.16a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,293.92,322.16Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M295.59,322.16a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,295.59,322.16Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M297.26,322.16a.1.1,0,0,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,321.06a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,289.75,321.06Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,321.06a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,291.42,321.06Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M293.09,321.06a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,293.09,321.06Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,321.06a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,294.76,321.06Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M296.43,321.06a.11.11,0,0,1-.1.1.11.11,0,0,1-.11-.1.1.1,0,0,1,.11-.1A.1.1,0,0,1,296.43,321.06Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M298.08,321.11a.09.09,0,0,1-.09.05.11.11,0,0,1-.1-.1.11.11,0,0,1,.07-.1Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M288.92,324.3a.1.1,0,0,1-.11.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.11.11,0,0,1,288.92,324.3Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,290.58,324.3Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M292.25,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,292.25,324.3Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,293.92,324.3Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M295.59,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,295.59,324.3Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M297.26,324.3a.1.1,0,0,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M298.93,324.3a.1.1,0,0,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M288.08,323.2a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,289.75,323.2Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,291.42,323.2Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M293.09,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,293.09,323.2Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,294.76,323.2Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M296.43,323.2a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,296.43,323.2Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1,323.2a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,298.1,323.2Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M287.25,326.45a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,287.25,326.45Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M288.92,326.45a.1.1,0,0,1-.11.1.1.1,0,0,1,0-.2A.1.1,0,0,1,288.92,326.45Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,290.58,326.45Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M292.25,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,292.25,326.45Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,293.92,326.45Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M295.59,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,295.59,326.45Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M297.26,326.45a.1.1,0,1,1-.1-.1A.09.09,0,0,1,297.26,326.45Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M298.93,326.45a.1.1,0,1,1-.1-.1A.09.09,0,0,1,298.93,326.45Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M288.08,325.35a.1.1,0,1,1-.1-.1A.09.09,0,0,1,288.08,325.35Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,289.75,325.35Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,291.42,325.35Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M293.09,325.35a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,293.09,325.35Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,294.76,325.35Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M296.43,325.35a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,296.43,325.35Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1,325.35a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,298.1,325.35Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M299.77,325.35a.1.1,0,0,1-.11.1.1.1,0,1,1,0-.2A.1.1,0,0,1,299.77,325.35Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M287.25,328.59a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,287.25,328.59Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M288.92,328.59a.11.11,0,0,1-.11.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.11.11,0,0,1,288.92,328.59Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,290.58,328.59Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M292.25,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,292.25,328.59Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,293.92,328.59Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M295.59,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,295.59,328.59Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M297.26,328.59a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M298.93,328.59a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M288.08,327.49a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,289.75,327.49Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,291.42,327.49Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M293.09,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,293.09,327.49Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,294.76,327.49Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M296.43,327.49a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,296.43,327.49Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1,327.49a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,298.1,327.49Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M299.77,327.49a.11.11,0,0,1-.11.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.11.11,0,0,1,299.77,327.49Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M288.08,329.64a.1.1,0,1,1-.1-.1A.09.09,0,0,1,288.08,329.64Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M289.75,329.64a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,289.75,329.64Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,329.64a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,291.42,329.64Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M293.09,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,293.09,329.64Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,294.76,329.64Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M296.43,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,296.43,329.64Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M298.1,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,298.1,329.64Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M299.64,329.54l-.05,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,321.07a.81.81,0,1,1-.81-.81A.82.82,0,0,1,291.51,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92,321.07a.81.81,0,1,1-.81-.81A.82.82,0,0,1,296.92,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.25,321.07a.55.55,0,0,1-.55.55.54.54,0,0,1-.55-.55.55.55,0,0,1,.55-.55A.55.55,0,0,1,291.25,321.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,321.07a.55.55,0,1,1-1.1,0,.55.55,0,1,1,1.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.11,321.19a.31.31,0,0,1-.31-.31,15.76,15.76,0,0,0-.46-2.91c-.31-1.16-.89-2.55-1.86-2.55-1.8,0-2.47,4.54-2.47,5.46a.31.31,0,0,1-.62,0c0-.06.37-6.08,3.09-6.08s2.94,6,2.94,6.08A.31.31,0,0,1,296.11,321.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.83,
    y: 312.49,
    width: 19.61,
    height: 19.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.86,332.52H307.41V312.07h20.45Zm-19.61-.84H327V312.91H308.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53,329.83h-9.79c-2.65,0-2.22-2.11-1.59-4.33s1.58-5.59,3.94-5.59h5.09c2.37,0,3.31,3.36,3.94,5.59S325.18,329.83,322.53,329.83Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,320a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,314.82,320Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,320a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,316.49,320Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.05,
    cy: 320.01,
    r: 0.1
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,320a.1.1,0,0,1-.11.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.11.11,0,0,1,319.83,320Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15,322.16a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,313.15,322.16Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,322.16a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,314.82,322.16Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,322.16a.11.11,0,0,1-.1.1.11.11,0,0,1-.11-.1.1.1,0,0,1,.11-.1A.1.1,0,0,1,316.49,322.16Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.05,
    cy: 322.16,
    r: 0.1
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,322.16a.11.11,0,0,1-.11.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.1.1,0,0,1,319.83,322.16Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M321.49,322.16a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,321.49,322.16Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M314,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,314,321.06Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M315.65,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,315.65,321.06Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32,321.06a.1.1,0,0,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M319,321.06a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,321.06a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,320.66,321.06Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M322.31,321.11a.09.09,0,0,1-.08.05.1.1,0,0,1-.1-.1.11.11,0,0,1,.07-.1Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,313.15,324.3Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,314.82,324.3Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,324.3a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,316.49,324.3Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M318.16,324.3a.1.1,0,0,1-.11.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.11.11,0,0,1,318.16,324.3Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,324.3a.1.1,0,0,1-.11.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.11.11,0,0,1,319.83,324.3Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M321.49,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,321.49,324.3Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M323.16,324.3a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,323.16,324.3Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,312.31,323.2Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M314,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,314,323.2Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M315.65,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,315.65,323.2Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32,323.2a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M319,323.2a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,320.66,323.2Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M322.33,323.2a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,322.33,323.2Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.38,
    cy: 326.45,
    r: 0.1
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15,326.45a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,313.15,326.45Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,326.45a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,314.82,326.45Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,326.45a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,316.49,326.45Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.05,
    cy: 326.45,
    r: 0.1
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,326.45a.1.1,0,0,1-.11.1.1.1,0,0,1,0-.2A.1.1,0,0,1,319.83,326.45Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M321.49,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,321.49,326.45Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M323.16,326.45a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,323.16,326.45Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31,325.35a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,312.31,325.35Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M314,325.35a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,314,325.35Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M315.65,325.35a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,315.65,325.35Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32,325.35a.1.1,0,1,1-.1-.1A.09.09,0,0,1,317.32,325.35Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M319,325.35a.1.1,0,1,1-.1-.1A.09.09,0,0,1,319,325.35Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,320.66,325.35Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M322.33,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,322.33,325.35Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M324,325.35a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,324,325.35Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M311.48,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,311.48,328.59Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,313.15,328.59Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M314.82,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,314.82,328.59Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M316.49,328.59a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,316.49,328.59Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M318.16,328.59a.11.11,0,0,1-.11.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.11.11,0,0,1,318.16,328.59Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,328.59a.11.11,0,0,1-.11.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.11.11,0,0,1,319.83,328.59Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M321.49,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,321.49,328.59Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M323.16,328.59a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,323.16,328.59Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,312.31,327.49Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M314,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,314,327.49Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M315.65,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,315.65,327.49Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32,327.49a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M319,327.49a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,320.66,327.49Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M322.33,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,322.33,327.49Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M324,327.49a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,324,327.49Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M312.31,329.64a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,312.31,329.64Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M314,329.64a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,314,329.64Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M315.65,329.64a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,315.65,329.64Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M317.32,329.64a.1.1,0,1,1-.1-.1A.09.09,0,0,1,317.32,329.64Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M319,329.64a.1.1,0,1,1-.1-.1A.09.09,0,0,1,319,329.64Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M320.66,329.64a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,320.66,329.64Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M322.33,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,322.33,329.64Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M323.88,329.54l-.06,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M315.74,321.07a.81.81,0,1,1-.81-.81A.82.82,0,0,1,315.74,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.15,321.07a.81.81,0,1,1-.81-.81A.82.82,0,0,1,321.15,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.48,321.07a.55.55,0,0,1-1.1,0,.55.55,0,0,1,1.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.89,321.07a.54.54,0,0,1-.55.55.55.55,0,0,1-.55-.55.55.55,0,0,1,.55-.55A.55.55,0,0,1,320.89,321.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.34,321.19a.31.31,0,0,1-.31-.31,14.87,14.87,0,0,0-.46-2.91c-.31-1.16-.89-2.55-1.86-2.55-1.8,0-2.47,4.54-2.47,5.46a.31.31,0,0,1-.62,0c0-.06.38-6.08,3.09-6.08s2.94,6,2.94,6.08A.31.31,0,0,1,320.34,321.19Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.06,
    y: 312.49,
    width: 19.61,
    height: 19.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,329.83H337c-2.64,0-2.22-2.11-1.58-4.33s1.57-5.59,3.94-5.59h5.08c2.37,0,3.31,3.36,3.94,5.59S349.41,329.83,346.77,329.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M339.05,320a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,339.05,320Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72,320a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,340.72,320Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,320a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,342.39,320Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.96,
    cy: 320.01,
    r: 0.1
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M337.38,322.16a.1.1,0,0,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M339.05,322.16a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,339.05,322.16Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72,322.16a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,340.72,322.16Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,322.16a.11.11,0,0,1-.1.1.1.1,0,0,1-.1-.1.09.09,0,0,1,.1-.1A.1.1,0,0,1,342.39,322.16Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.96,
    cy: 322.16,
    r: 0.1
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M345.73,322.16a.11.11,0,0,1-.1.1.11.11,0,0,1-.11-.1.1.1,0,0,1,.11-.1A.1.1,0,0,1,345.73,322.16Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M338.22,321.06a.11.11,0,0,1-.11.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.1.1,0,0,1,338.22,321.06Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,339.88,321.06Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M341.55,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,341.55,321.06Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M343.22,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,343.22,321.06Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89,321.06a.1.1,0,0,1-.1.1.11.11,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.09.09,0,0,1,344.89,321.06Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M346.55,321.11a.11.11,0,0,1-.09.05.1.1,0,0,1-.1-.1.11.11,0,0,1,.07-.1Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M337.38,324.3a.1.1,0,0,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M339.05,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,339.05,324.3Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,340.72,324.3Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,342.39,324.3Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M344.06,324.3a.1.1,0,0,1-.1.1.09.09,0,0,1-.1-.1.1.1,0,0,1,.1-.1A.11.11,0,0,1,344.06,324.3Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M345.73,324.3a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,345.73,324.3Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4,324.3a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,347.4,324.3Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M336.55,323.2a.1.1,0,0,1-.1.1.1.1,0,0,1-.11-.1.11.11,0,0,1,.11-.1A.11.11,0,0,1,336.55,323.2Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M338.22,323.2a.1.1,0,0,1-.11.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.11.11,0,0,1,338.22,323.2Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,339.88,323.2Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M341.55,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,341.55,323.2Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M343.22,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,343.22,323.2Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89,323.2a.09.09,0,0,1-.1.1.1.1,0,0,1-.1-.1.11.11,0,0,1,.1-.1A.1.1,0,0,1,344.89,323.2Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M346.56,323.2a.1.1,0,0,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 335.61,
    cy: 326.45,
    r: 0.1
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M337.38,326.45a.1.1,0,1,1-.1-.1A.09.09,0,0,1,337.38,326.45Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M339.05,326.45a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,339.05,326.45Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72,326.45a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,340.72,326.45Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,326.45a.1.1,0,0,1-.1.1.1.1,0,0,1,0-.2A.1.1,0,0,1,342.39,326.45Z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.96,
    cy: 326.45,
    r: 0.1
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M345.73,326.45a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,345.73,326.45Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4,326.45a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,347.4,326.45Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M336.55,325.35a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,336.55,325.35Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M338.22,325.35a.1.1,0,0,1-.11.1.1.1,0,1,1,0-.2A.1.1,0,0,1,338.22,325.35Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88,325.35a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,339.88,325.35Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M341.55,325.35a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,341.55,325.35Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M343.22,325.35a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,343.22,325.35Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89,325.35a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,344.89,325.35Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M346.56,325.35a.1.1,0,1,1-.1-.1A.09.09,0,0,1,346.56,325.35Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M348.23,325.35a.1.1,0,1,1-.1-.1A.09.09,0,0,1,348.23,325.35Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M335.71,328.59a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M337.38,328.59a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M339.05,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,339.05,328.59Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,340.72,328.59Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M342.39,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,342.39,328.59Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M344.06,328.59a.11.11,0,0,1-.1.11.1.1,0,0,1-.1-.11.1.1,0,0,1,.1-.1A.11.11,0,0,1,344.06,328.59Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M345.73,328.59a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,345.73,328.59Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M347.4,328.59a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,347.4,328.59Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M336.55,327.49a.11.11,0,0,1-.1.11.11.11,0,0,1-.11-.11.11.11,0,0,1,.11-.1A.11.11,0,0,1,336.55,327.49Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M338.22,327.49a.11.11,0,0,1-.11.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.11.11,0,0,1,338.22,327.49Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,339.88,327.49Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M341.55,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,341.55,327.49Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M343.22,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,343.22,327.49Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89,327.49a.1.1,0,0,1-.1.11.11.11,0,0,1-.1-.11.11.11,0,0,1,.1-.1A.1.1,0,0,1,344.89,327.49Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M346.56,327.49a.1.1,0,1,1-.2,0,.1.1,0,1,1,.2,0Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M348.23,327.49a.1.1,0,1,1-.2,0,.1.1,0,0,1,.2,0Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M336.55,329.64a.1.1,0,0,1-.1.1.1.1,0,1,1,0-.2A.1.1,0,0,1,336.55,329.64Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M338.22,329.64a.1.1,0,0,1-.11.1.1.1,0,1,1,0-.2A.1.1,0,0,1,338.22,329.64Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M339.88,329.64a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,339.88,329.64Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M341.55,329.64a.09.09,0,0,1-.1.1.1.1,0,0,1,0-.2A.09.09,0,0,1,341.55,329.64Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M343.22,329.64a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,343.22,329.64Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89,329.64a.09.09,0,0,1-.1.1.1.1,0,1,1,0-.2A.09.09,0,0,1,344.89,329.64Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M346.56,329.64a.1.1,0,1,1-.1-.1A.09.09,0,0,1,346.56,329.64Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M348.11,329.54l-.05,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M340,321.07a.82.82,0,1,1-.82-.81A.82.82,0,0,1,340,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,321.07a.82.82,0,1,1-.81-.81A.82.82,0,0,1,345.39,321.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.71,321.07a.54.54,0,0,1-.55.55.55.55,0,0,1-.55-.55.55.55,0,0,1,.55-.55A.55.55,0,0,1,339.71,321.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.13,321.07a.55.55,0,0,1-.55.55.54.54,0,0,1-.55-.55.55.55,0,0,1,.55-.55A.55.55,0,0,1,345.13,321.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.58,321.19a.31.31,0,0,1-.31-.31,15.25,15.25,0,0,0-.47-2.91c-.31-1.16-.88-2.55-1.86-2.55-1.79,0-2.47,4.54-2.47,5.46a.31.31,0,0,1-.62,0c0-.06.38-6.08,3.09-6.08s2.95,6,2.95,6.08A.31.31,0,0,1,344.58,321.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.04,
    y: 113.35,
    width: 151.17,
    height: 7.48,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,119a.37.37,0,0,1-.38.38.38.38,0,0,1-.36-.28.31.31,0,0,1,0-.1v-4a.38.38,0,0,1,.75,0v1.18a1.65,1.65,0,0,1,.73-.19,1.49,1.49,0,0,1,1.48,1.49V119a.37.37,0,1,1-.74,0V117.5a.74.74,0,1,0-1.47,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,116.38a.39.39,0,0,1-.38.38h-.17v1.89a.37.37,0,0,1,.37.38.37.37,0,0,1-.37.38.76.76,0,0,1-.76-.76v-1.89H271a.38.38,0,0,1-.38-.38A.37.37,0,0,1,271,116h.19v-1a.38.38,0,0,1,.39-.37.36.36,0,0,1,.37.37v1h.17A.38.38,0,0,1,272.48,116.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.78,116.38a.39.39,0,0,1-.39.38h-.17v1.89a.38.38,0,0,1,.38.38.37.37,0,0,1-.38.38.76.76,0,0,1-.75-.76v-1.89h-.2a.37.37,0,0,1-.37-.38.36.36,0,0,1,.37-.37h.2v-1a.37.37,0,0,1,.38-.37.36.36,0,0,1,.37.37v1h.17A.38.38,0,0,1,274.78,116.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,120.32v-2.6h0v-1.35a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.28,1.68,1.68,0,1,1,.93,3.11,1.54,1.54,0,0,1-.91-.28v1.2a.39.39,0,0,1-.39.37A.37.37,0,0,1,276,120.32Zm.75-2.6a.9.9,0,0,0,.26.68.85.85,0,0,0,.65.28.87.87,0,0,0,.64-.28,1,1,0,0,0,.26-.68,1.06,1.06,0,0,0-.26-.69.87.87,0,0,0-.64-.28.85.85,0,0,0-.65.28A.93.93,0,0,0,276.72,117.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.92,115.73a.52.52,0,0,1,.51.51.51.51,0,0,1-.51.51.5.5,0,0,1-.5-.51A.51.51,0,0,1,280.92,115.73Zm0,2.71a.51.51,0,0,1,0,1,.51.51,0,0,1,0-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,118.89l1.67-4a.37.37,0,0,1,.49-.19.35.35,0,0,1,.19.48l-1.66,4a.39.39,0,0,1-.35.23.35.35,0,0,1-.14,0A.37.37,0,0,1,282,118.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75,118.89l1.67-4a.38.38,0,0,1,.5-.19.37.37,0,0,1,.19.48l-1.67,4a.37.37,0,0,1-.35.23.31.31,0,0,1-.13,0A.37.37,0,0,1,283.75,118.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,101.41V412.89c0,8.8-6.59,15.92-14.72,15.92H88.7c-8.15,0-14.75-7.12-14.75-15.92V101.41C74,83.47,80.55,82.6,88.7,82.6h29.11c1.69,0,3.08,1.92,3.08,4.3v1c0,5.59,3,5.61,6.81,5.61H195c3.79,0,6.82,0,6.82-5.61v-1c0-2.38,1.36-4.3,3.08-4.3h29.13C242.2,82.6,248.79,85,248.79,101.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.07,429.19H88.7c-8.34,0-15.12-7.31-15.12-16.3V101.41c0-17.78,6.55-19.19,15.12-19.19h29.11c1.9,0,3.45,2.1,3.45,4.68v1c0,5.23,2.7,5.23,6.44,5.23H195c3.74,0,6.44,0,6.44-5.23v-1c0-2.62,1.52-4.68,3.46-4.68h29.13c9.06,0,15.1,3.26,15.1,19.19V412.89C249.17,421.88,242.39,429.19,234.07,429.19ZM88.7,83c-8.42,0-14.37,1.32-14.37,18.44V412.89c0,8.57,6.44,15.55,14.37,15.55H234.07c7.91,0,14.35-7,14.35-15.55V101.41c0-15.35-5.49-18.44-14.35-18.44H204.94c-1.49,0-2.71,1.77-2.71,3.93v1c0,6-3.49,6-7.19,6H127.7c-3.7,0-7.19,0-7.19-6v-1c0-2.16-1.21-3.93-2.7-3.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79,101.41v23.24H74V101.41C74,83.47,80.54,82.6,88.69,82.6H234.06C242.19,82.6,248.79,85,248.79,101.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.79,89.59l-.28.28-.16.16a3.84,3.84,0,0,0-5.43,0l-.15-.16a3.7,3.7,0,0,0-.28-.28h0l0,0,.35-.32a4.37,4.37,0,0,1,.82-.52,4.25,4.25,0,0,1,1.09-.37l.55-.07h.48l.37,0a4.41,4.41,0,0,1,1,.24,4.12,4.12,0,0,1,.67.32,4.18,4.18,0,0,1,.65.45l.3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,90.92l-.45-.44a3.11,3.11,0,0,1,1.81-.91,3.17,3.17,0,0,1,2.72.9l-.45.44a2.56,2.56,0,0,0-3.63,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,91.36l-.44.44a1.34,1.34,0,0,0-1.87,0l-.44-.44A1.94,1.94,0,0,1,111,91.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,92.2a.39.39,0,0,1-.4.4.39.39,0,0,1-.4-.4.39.39,0,0,1,.4-.4A.4.4,0,0,1,110,92.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,85.35,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,89,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.65,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,92.65,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,96.3,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,90.44a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,100,90.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,93h-9.45V88.59h9.45Zm-9-.5h8.45V89.09h-8.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.02,
    y: 89.35,
    width: 6.08,
    height: 2.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 89.62,
    width: 0.84,
    height: 2.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,157.34a9.75,9.75,0,1,1,4.35-10.61A9.77,9.77,0,0,1,105.27,157.34Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11,147.93a3,3,0,1,1-3-3A3,3,0,0,1,103.11,147.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,156.11v1.23a9.71,9.71,0,0,1-10.25,0v-1.22a5.13,5.13,0,1,1,10.25,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.13,
    y: 139.84,
    width: 62.01,
    height: 5.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.13,
    y: 148.37,
    width: 54.12,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.13,
    y: 154.89,
    width: 89.5,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 174.6,
    width: 57.3,
    height: 40.12,
    transform: "translate(249.52 389.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,186a4.75,4.75,0,1,0,4.75-4.75A4.75,4.75,0,0,0,102.81,186Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.56 206 153.42 206 137.49 184.4 121.56 206",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.06 206.1 135.37 206.1 122.22 192.04 109.06 206.1",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 206.08,
    width: 57.3,
    height: 8.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 175.19,
    width: 36.87,
    height: 5.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 183.71,
    width: 58.93,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 190.1,
    width: 58.93,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 196.49,
    width: 58.93,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 202.88,
    width: 58.93,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 209.27,
    width: 39.88,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 222.05,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 228.44,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 234.82,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 241.21,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 247.6,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 253.99,
    width: 77.51,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 266.77,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 273.16,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 279.55,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 285.94,
    width: 98.89,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 298.71,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 305.1,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 311.49,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 317.88,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 324.27,
    width: 95.12,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 337.05,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 343.44,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 349.83,
    width: 130.52,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 356.21,
    width: 51.98,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.11,
    y: 370.03,
    width: 57.3,
    height: 21.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,381.44a4.75,4.75,0,1,0,4.75-4.75A4.75,4.75,0,0,0,102.81,381.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.86 391.18 129.12 391.18 137.49 379.84 145.86 391.18",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.69 391.18 118.74 391.18 122.21 387.47 125.69 391.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 370.62,
    width: 36.87,
    height: 5.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 379.14,
    width: 58.93,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.7,
    y: 385.66,
    width: 23.96,
    height: 3.39,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.77 391.18 226.92 391.36 205.06 391.43 161.36 391.55 117.66 391.43 95.81 391.36 73.96 391.18 95.81 391 117.66 390.93 161.36 390.81 205.06 390.93 226.92 391 248.77 391.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.53 412.27 93.25 409.2 96.53 406.13 97.03 406.67 94.34 409.2 97.03 411.73 96.53 412.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.69 406.13 129.97 409.2 126.69 412.27 126.19 411.73 128.88 409.2 126.19 406.67 126.69 406.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.4 414.31 158.63 414.31 158.63 407.54 160.84 407.54 160.84 408.29 159.38 408.29 159.38 413.56 164.65 413.56 164.65 408.29 163.2 408.29 163.2 407.54 165.4 407.54 165.4 414.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.62,
    y: 404.46,
    width: 0.75,
    height: 6.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.72 406.82 162.02 405 160.31 406.82 159.76 406.31 162.02 403.91 164.27 406.31 163.72 406.82",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.55,405.47l-.11,0a8.84,8.84,0,0,0-4.65,0l-.3.08v7.69l.51-.14a8.33,8.33,0,0,1,4-.07l.3.07.11,0,.11,0c.1,0,.19-.05.29-.06v-7.49Zm-.52,6.74a9.06,9.06,0,0,0-3.74,0v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.09,405.47a8.84,8.84,0,0,0-4.65,0l-.11,0-.3.08V413l.3.07.11,0,.11,0c.1,0,.19-.05.29-.06a8.13,8.13,0,0,1,4,.06l.5.14v-7.69Zm-.51,6.74a8.84,8.84,0,0,0-3.74,0v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.83 411.55 221.52 411.55 221.52 405.16 227.92 405.16 227.92 407.22 227.17 407.22 227.17 405.91 222.27 405.91 222.27 410.8 223.83 410.8 223.83 411.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.85,413.23h-6.39v-6.39h6.39Zm-5.64-.75h4.89v-4.89h-4.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.78,
    y: 113.35,
    width: 151.17,
    height: 7.48,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.27,119a.37.37,0,0,1-.38.38.38.38,0,0,1-.36-.28.31.31,0,0,1,0-.1v-4a.38.38,0,0,1,.75,0v1.18A1.65,1.65,0,0,1,91,116a1.49,1.49,0,0,1,1.48,1.49V119a.37.37,0,1,1-.74,0V117.5a.74.74,0,1,0-1.47,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.22,116.38a.39.39,0,0,1-.38.38h-.17v1.89A.37.37,0,0,1,95,119a.37.37,0,0,1-.37.38.76.76,0,0,1-.76-.76v-1.89h-.19a.38.38,0,0,1-.38-.38.37.37,0,0,1,.38-.37h.19v-1a.37.37,0,0,1,.39-.37.36.36,0,0,1,.37.37v1h.17A.38.38,0,0,1,95.22,116.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,116.38a.38.38,0,0,1-.38.38H97v1.89a.38.38,0,0,1,.38.38.37.37,0,0,1-.38.38.76.76,0,0,1-.75-.76v-1.89H96a.37.37,0,0,1-.37-.38A.36.36,0,0,1,96,116h.2v-1a.37.37,0,0,1,.38-.37A.36.36,0,0,1,97,115v1h.17A.37.37,0,0,1,97.51,116.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.71,120.32v-2.6h0v-1.35a.36.36,0,0,1,.36-.36.37.37,0,0,1,.37.28,1.68,1.68,0,1,1,.93,3.11,1.59,1.59,0,0,1-.92-.28v1.2a.38.38,0,0,1-.38.37A.37.37,0,0,1,98.71,120.32Zm.74-2.6a.91.91,0,0,0,.27.68.83.83,0,0,0,.65.28.87.87,0,0,0,.64-.28,1,1,0,0,0,.26-.68A1.06,1.06,0,0,0,101,117a.87.87,0,0,0-.64-.28.83.83,0,0,0-.65.28A.93.93,0,0,0,99.45,117.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,115.73a.52.52,0,0,1,.51.51.51.51,0,0,1-.51.51.5.5,0,0,1-.5-.51A.51.51,0,0,1,103.66,115.73Zm0,2.71a.51.51,0,0,1,0,1,.51.51,0,0,1,0-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78,118.89l1.67-4a.37.37,0,0,1,.49-.19.36.36,0,0,1,.19.48l-1.66,4a.39.39,0,0,1-.35.23.35.35,0,0,1-.14,0A.37.37,0,0,1,104.78,118.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.49,118.89l1.67-4a.38.38,0,0,1,.5-.19.37.37,0,0,1,.19.48l-1.67,4a.37.37,0,0,1-.35.23.31.31,0,0,1-.13,0A.37.37,0,0,1,106.49,118.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.23,61.24H168.75A16.59,16.59,0,0,0,152.31,78v334.5a16.6,16.6,0,0,0,16.44,16.74H331.23a16.61,16.61,0,0,0,16.46-16.74V78A16.6,16.6,0,0,0,331.23,61.24Zm6.18,340.9c0,8.81-6.59,15.93-14.72,15.93H177.32c-8.15,0-14.74-7.12-14.74-15.93V90.66c0-17.93,6.59-18.81,14.74-18.81h29.11c1.7,0,3.08,1.93,3.08,4.31v1c0,5.58,3.06,5.6,6.82,5.6h67.34c3.78,0,6.81,0,6.81-5.6v-1c0-2.38,1.36-4.31,3.09-4.31h29.12c8.13,0,14.72,2.39,14.72,18.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.18,75.82H240.81a1.14,1.14,0,0,1-1.13-1.14h0a1.14,1.14,0,0,1,1.13-1.13h18.37a1.14,1.14,0,0,1,1.14,1.13h0A1.14,1.14,0,0,1,259.18,75.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,90.66V402.14c0,8.81-6.59,15.93-14.72,15.93H177.32c-8.15,0-14.74-7.12-14.74-15.93V90.66c0-17.93,6.59-18.81,14.74-18.81h29.11c1.7,0,3.08,1.93,3.08,4.31v1c0,5.58,3.06,5.6,6.82,5.6h67.34c3.78,0,6.81,0,6.81-5.6v-1c0-2.38,1.36-4.31,3.09-4.31h29.12C330.82,71.85,337.41,74.24,337.41,90.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,90.66v14.89H162.57V90.66c0-17.93,6.59-18.81,14.75-18.81h29.12c1.69,0,3.08,1.93,3.08,4.31v1c0,5.58,3,5.6,6.8,5.6h67.34c3.79,0,6.82,0,6.82-5.6v-1c0-2.38,1.37-4.31,3.09-4.31h29.11C330.82,71.85,337.41,74.24,337.41,90.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.41,78.85l-.28.28-.16.16a3.81,3.81,0,0,0-2.71-1.13,3.77,3.77,0,0,0-2.71,1.13l-.16-.16-.27-.28h0l.35-.32a4,4,0,0,1,.83-.52,4.13,4.13,0,0,1,1.09-.37l.54-.07h.48c.12,0,.25,0,.37,0a3.84,3.84,0,0,1,1,.24,4.17,4.17,0,0,1,.68.31,3.57,3.57,0,0,1,.64.46l.3.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.44,80.17l-.45-.44a3.24,3.24,0,0,1,1.81-.91,3.16,3.16,0,0,1,2.72.91l-.44.44a2.58,2.58,0,0,0-3.64,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.63,80.62l-.44.44a1.31,1.31,0,0,0-.93-.39,1.28,1.28,0,0,0-.93.39l-.45-.44A1.93,1.93,0,0,1,199.63,80.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,81.46a.4.4,0,1,1-.4-.4A.4.4,0,0,1,198.66,81.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 175.13,
    cy: 79.7,
    r: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,79.7a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,177.62,79.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.43,
    cy: 79.7,
    r: 1.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,79.7a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,184.92,79.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.57,79.7a1.16,1.16,0,1,1,1.16,1.16A1.16,1.16,0,0,1,188.57,79.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.31,82.24h-9.46V77.85h9.46Zm-9-.5h8.46V78.35h-8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 78.6,
    width: 6.08,
    height: 2.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.3,
    y: 78.88,
    width: 0.84,
    height: 2.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.58 268.66 184.43 268.48 206.28 268.41 249.98 268.29 293.68 268.41 315.53 268.48 337.39 268.66 315.53 268.84 293.68 268.91 249.98 269.04 206.28 268.91 184.43 268.84 162.58 268.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.58 324.47 184.43 324.29 206.28 324.22 249.98 324.09 293.68 324.22 315.53 324.29 337.39 324.47 315.53 324.65 293.68 324.72 249.98 324.84 206.28 324.72 184.43 324.65 162.58 324.47",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.58 386.52 184.43 386.34 206.28 386.27 249.98 386.15 293.68 386.27 315.53 386.34 337.39 386.52 315.53 386.71 293.68 386.77 249.98 386.9 206.28 386.77 184.43 386.7 162.58 386.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.59,
    y: 121.61,
    width: 174.83,
    height: 115.76,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.85,179.49A19.85,19.85,0,1,1,250,159.64,19.85,19.85,0,0,1,269.85,179.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.63 187.88 241.63 171.1 262.61 179.49 241.63 187.88",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.59,
    y: 228.33,
    width: 174.83,
    height: 9.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.18,
    y: 231.51,
    width: 147.15,
    height: 2.68,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.18,
    y: 230,
    width: 5.72,
    height: 5.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.52,
    y: 231.02,
    width: 1.08,
    height: 3.68,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.47,
    y: 231.02,
    width: 1.08,
    height: 3.68,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.67,
    y: 229.99,
    width: 5.72,
    height: 5.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.53,
    y: 232.15,
    width: 1.12,
    height: 1.39,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.9 234.43 324.21 233.54 324.21 232.15 325.9 231.26 325.9 234.43",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.73,231.79l.26-.26a1.83,1.83,0,0,1,.53,1.05,1.86,1.86,0,0,1-.53,1.58l-.25-.26a1.51,1.51,0,0,0,.43-1.06A1.44,1.44,0,0,0,326.73,231.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,233.64l-.26-.26a.77.77,0,0,0,0-1.08l.26-.25A1.12,1.12,0,0,1,326.48,233.64Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.49,
    y: 229.98,
    width: 5.72,
    height: 5.72,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.41,
    y: 230.9,
    width: 2.36,
    height: 2.36,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.97,
    y: 232.53,
    width: 2.36,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.76,232.86a3,3,0,0,0,.3,1.34H173.19v-2.69h27.88A2.91,2.91,0,0,0,200.76,232.86Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.87,232.86a3,3,0,0,1-.3,1.34,3.07,3.07,0,0,1-2.76,1.71,3,3,0,0,1-2.75-1.71,3,3,0,0,1-.3-1.34,2.91,2.91,0,0,1,.31-1.35,3,3,0,0,1,2.74-1.72,3.06,3.06,0,0,1,3.06,3.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.49,
    y: 246.97,
    width: 82.13,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.49,
    y: 252.47,
    width: 39.21,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,258.29a6.87,6.87,0,0,1-7.27,0,6.92,6.92,0,1,1,7.27,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21,251.62a2.11,2.11,0,1,1-2.1-2.11A2.1,2.1,0,0,1,182.21,251.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,257.43v.86a6.87,6.87,0,0,1-7.27,0v-.86a3.64,3.64,0,1,1,7.27,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.32,
    y: 276.82,
    width: 59.29,
    height: 39.26,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,296.45a6.73,6.73,0,1,1-6.73-6.73A6.73,6.73,0,0,1,210.7,296.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.13 299.29 201.13 293.6 208.25 296.45 201.13 299.29",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.33,
    y: 313.01,
    width: 59.29,
    height: 3.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.92,
    y: 314.09,
    width: 49.9,
    height: 0.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.87,
    y: 313.58,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.32,
    y: 313.92,
    width: 0.37,
    height: 1.25,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.98,
    y: 313.92,
    width: 0.37,
    height: 1.25,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.62,
    y: 313.57,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.91,
    y: 314.31,
    width: 0.38,
    height: 0.47,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.71 315.08 229.14 314.78 229.14 314.31 229.71 314 229.71 315.08",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230,314.18l.09-.08a.59.59,0,0,1,.18.35.63.63,0,0,1-.18.54l-.09-.09a.51.51,0,0,0,0-.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,314.81l-.08-.09a.27.27,0,0,0,0-.36l.08-.09A.37.37,0,0,1,229.9,314.81Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 230.93,
    y: 313.57,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.24,
    y: 313.88,
    width: 0.8,
    height: 0.8,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.77,
    y: 314.44,
    width: 0.8,
    height: 0.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27,314.55a1,1,0,0,0,.1.45h-9.45v-.91h9.46A1,1,0,0,0,187.27,314.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,314.55a1,1,0,0,1-.1.45,1,1,0,0,1-1.87,0,1,1,0,0,1-.1-.45,1,1,0,0,1,.11-.46,1,1,0,0,1,.92-.58,1,1,0,0,1,.94.58A1.11,1.11,0,0,1,189.34,314.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 276.82,
    width: 82.13,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 282.32,
    width: 39.21,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.32,
    y: 333.33,
    width: 59.29,
    height: 39.26,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.7,353a6.73,6.73,0,1,1-6.73-6.73A6.73,6.73,0,0,1,210.7,353Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.13 355.81 201.13 350.12 208.25 352.96 201.13 355.81",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.33,
    y: 369.53,
    width: 59.29,
    height: 3.07,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.92,
    y: 370.6,
    width: 49.9,
    height: 0.91,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.87,
    y: 370.09,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.32,
    y: 370.44,
    width: 0.37,
    height: 1.25,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.98,
    y: 370.44,
    width: 0.37,
    height: 1.25,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.62,
    y: 370.09,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.91,
    y: 370.82,
    width: 0.38,
    height: 0.47,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.71 371.59 229.14 371.29 229.14 370.82 229.71 370.52 229.71 371.59",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230,370.7l.09-.09a.63.63,0,0,1,0,.89l-.09-.09a.47.47,0,0,0,.15-.35A.49.49,0,0,0,230,370.7Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.9,371.33l-.08-.09a.24.24,0,0,0,.07-.18.25.25,0,0,0-.07-.19l.08-.08A.37.37,0,0,1,229.9,371.33Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 230.93,
    y: 370.09,
    width: 1.94,
    height: 1.94,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.24,
    y: 370.4,
    width: 0.8,
    height: 0.8,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.77,
    y: 370.95,
    width: 0.8,
    height: 0.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27,371.06a1,1,0,0,0,.1.46h-9.45v-.92h9.46A1,1,0,0,0,187.27,371.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,371.06a1,1,0,0,1-.1.46,1,1,0,0,1-1.87,0,1,1,0,0,1-.1-.46,1,1,0,0,1,.11-.46,1,1,0,0,1,.92-.58,1.06,1.06,0,0,1,.94.58A1.19,1.19,0,0,1,189.34,371.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 333.33,
    width: 82.13,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.09,
    y: 338.83,
    width: 39.21,
    height: 3.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.49 402.7 181.21 399.63 184.49 396.56 185 397.1 182.3 399.63 185 402.16 184.49 402.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.66 396.56 217.93 399.63 214.66 402.7 214.15 402.16 216.85 399.63 214.15 397.1 214.66 396.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.37 404.75 246.59 404.75 246.59 397.97 248.8 397.97 248.8 398.72 247.34 398.72 247.34 404 252.62 404 252.62 398.72 251.16 398.72 251.16 397.97 253.37 397.97 253.37 404.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.59,
    y: 394.89,
    width: 0.75,
    height: 6.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.28 397.26 247.73 396.75 249.98 394.34 252.23 396.75 251.69 397.26 249.98 395.44 248.28 397.26",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,395.91a.19.19,0,0,0-.1,0,9,9,0,0,0-4.66,0l-.3.07v7.7l.52-.14a8.21,8.21,0,0,1,4-.08l.3.08.11,0,.1,0c.1,0,.2-.06.29-.07V396Zm-.51,6.74a8.74,8.74,0,0,0-3.74,0v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.06,395.91a8.94,8.94,0,0,0-4.65,0,.2.2,0,0,0-.11,0l-.3.07v7.48l.3.08.11,0,.1,0c.1,0,.2-.06.29-.07a8,8,0,0,1,4,.07l.51.14V396Zm-.52,6.74a8.35,8.35,0,0,0-1.86-.21,8.53,8.53,0,0,0-1.88.21v-6a8.15,8.15,0,0,1,3.74,0Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.79 401.98 309.49 401.98 309.49 395.6 315.89 395.6 315.89 397.65 315.14 397.65 315.14 396.35 310.24 396.35 310.24 401.23 311.79 401.23 311.79 401.98",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.81,403.67h-6.39v-6.4h6.39Zm-5.64-.75h4.89V398h-4.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.98,
    y: 411.76,
    width: 50.03,
    height: 1.61,
    rx: 0.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.98,
    y: 94.64,
    width: 151.17,
    height: 7.48,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.46,100.32a.38.38,0,0,1-.38.38.4.4,0,0,1-.36-.28.31.31,0,0,1,0-.1v-4a.38.38,0,1,1,.75,0v1.18a1.66,1.66,0,0,1,.73-.2,1.5,1.5,0,0,1,1.49,1.5v1.53a.38.38,0,0,1-.38.38.37.37,0,0,1-.37-.38V98.79a.74.74,0,1,0-1.47,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.41,97.67A.38.38,0,0,1,183,98h-.17v1.9a.38.38,0,1,1,0,.76.76.76,0,0,1-.75-.76V98h-.2a.38.38,0,1,1,0-.75h.2v-1a.38.38,0,0,1,.38-.38.37.37,0,0,1,.37.38v1H183A.38.38,0,0,1,183.41,97.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,97.67a.38.38,0,0,1-.38.37h-.18v1.9a.38.38,0,1,1,0,.76.76.76,0,0,1-.75-.76V98h-.2a.38.38,0,0,1,0-.75h.2v-1a.38.38,0,0,1,.38-.38.37.37,0,0,1,.37.38v1h.18A.39.39,0,0,1,185.71,97.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,101.61V99h0V97.66a.37.37,0,0,1,.36-.37.36.36,0,0,1,.37.28,1.76,1.76,0,0,1,.93-.28A1.7,1.7,0,0,1,190.21,99a1.67,1.67,0,0,1-1.65,1.69,1.54,1.54,0,0,1-.91-.28v1.2a.39.39,0,0,1-.39.37A.37.37,0,0,1,186.9,101.61Zm.75-2.61a.88.88,0,0,0,.26.68.86.86,0,0,0,.65.29.88.88,0,0,0,.64-.29,1,1,0,0,0,.26-.68,1.06,1.06,0,0,0-.26-.68.87.87,0,0,0-.64-.28.85.85,0,0,0-.65.28A.92.92,0,0,0,187.65,99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.85,97a.51.51,0,1,1,0,1,.51.51,0,0,1,0-1Zm0,2.71a.51.51,0,0,1,0,1,.51.51,0,0,1,0-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,100.18l1.67-4a.36.36,0,0,1,.49-.19.35.35,0,0,1,.19.48l-1.66,4a.38.38,0,0,1-.35.23.35.35,0,0,1-.14,0A.37.37,0,0,1,193,100.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,100.18l1.66-4a.37.37,0,0,1,.5-.19.36.36,0,0,1,.19.48l-1.67,4a.36.36,0,0,1-.34.23.32.32,0,0,1-.14,0A.36.36,0,0,1,194.69,100.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.98,
    y: 110.85,
    width: 12.16,
    height: 7.49,
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.97 116.51 177.97 112.67 182.76 114.59 177.97 116.51",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.32,340.51c-12.06,16.33-24.62,35.27-27.68,55.74a.27.27,0,0,0,.53.1A122.49,122.49,0,0,1,78.5,380c7.92-2.18,15.7-4,19.86-11.83,4.24-8.09,3.7-18.63,2.9-27.43C101.2,340.22,100.56,340.2,100.32,340.51Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.62,379.81C84,367.66,91,355.46,99.82,345.47c.06-.07.15,0,.09.1-5.78,7.11-10.18,14.86-14.47,22.75,4-4.05,8.37-7.68,12.15-12,.07-.08.19,0,.12.12C94,361,89.85,365.86,85,369.19c-1.32,2.42-2.64,4.85-4,7.28.33-.19.67-.35,1-.52.06,0,.12.06.06.09-.38.19-.75.39-1.13.55-.64,1.15-1.26,2.3-1.92,3.45C78.86,380.29,78.5,380.07,78.62,379.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.64,375.57a71.65,71.65,0,0,0,9.26-6.17c.08-.07.19,0,.11.11a48.68,48.68,0,0,1-9.23,6.29A.13.13,0,0,1,82.64,375.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,393.21c0,.25.45.24.44,0,.07-6.74,0-13.52.11-20.29,1.73-3.48,5.43-5.41,8-8.2a35.91,35.91,0,0,0,4.81-6.7,48.1,48.1,0,0,0,5.58-18.59c.71-7.21-2-31-5.07-30.18-1.57.43-6.67,12.21-8,16.11a113.55,113.55,0,0,0-4.8,19.75C69.83,361,70,377.24,71.24,393.21Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.19,364.13l0,0c.37-8.53,2.3-17.14,4.09-25.41,1.94-8.92,4.21-17.31,8.79-25.26a.13.13,0,0,1,.23.14A94,94,0,0,0,77.27,333c.31-.48.68-.94,1-1.39.13-.18.42,0,.3.17a12.2,12.2,0,0,1-1.44,2,.07.07,0,0,1-.06,0c-1.57,6.37-2.71,12.89-3.68,19.39.07-.08.14-.17.22-.25s.13,0,.1.08-.26.42-.39.64c-.49,3.3-.94,6.59-1.4,9.85,5.88-5,10.89-10.93,13.72-18.23,0,0,.07,0,.06,0-2.77,7.56-7.14,14.29-13.87,18.88-.12.87-.25,1.75-.37,2.63,0,.18-.32.13-.32,0,0-.78,0-1.56.08-2.34A.17.17,0,0,1,71.19,364.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,351.77c4.49-6.7,8.68-13.21,12-20.61,0-.08.18,0,.14.06-2.76,7.36-6.64,14.81-11.88,20.72C74.08,352.06,73.87,351.91,74,351.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,329.5c1.86-3.29,3.82-6.49,5.57-9.84,0-.1.18,0,.14.08a51.16,51.16,0,0,1-5.43,9.93A.16.16,0,0,1,79.93,329.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,330.94s0,.05,0,.05S79.16,330.94,79.2,330.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.68,373.71A68,68,0,0,1,65.1,387c.07.48.14,1,.21,1.46a63.14,63.14,0,0,0,2.38-14.81.43.43,0,0,0,0-.45v0a98.66,98.66,0,0,0-1.49-20.06c-2.09-12.38-6.65-24.27-15.29-33.56a.61.61,0,0,0-1,.2c-3.49,8.86-2.27,19.44.7,28.28a51.52,51.52,0,0,0,6.85,13.44C60.49,365.64,64.27,369.16,66.68,373.71Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,323.7c8.19,13.29,13.89,29.05,14.59,44.74,0,.28-.46.35-.5.07-.19-1.41-.41-2.81-.63-4.2h0c-3.39-3.24-6.86-6.66-9.29-10.72a.08.08,0,0,1,.12-.09,113.46,113.46,0,0,0,9,9.82q-.87-5.21-2.1-10.25l-.65-.76c-.14-.17.1-.41.24-.24a2.09,2.09,0,0,1,.2.22,117.2,117.2,0,0,0-4.28-13.6c-2.08-2.48-4.41-4.63-5.93-7.63a.06.06,0,0,1,.11-.06c1.22,1.71,2.4,3.44,3.78,5,.55.63,1.16,1.22,1.73,1.84a103.77,103.77,0,0,0-6.7-14A.18.18,0,0,1,52,323.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.61,340.09c2.65,3.57,5.66,7,8.12,10.65.07.1-.08.21-.17.13-3.16-3-5.83-7-8.13-10.67C53.36,340.08,53.53,340,53.61,340.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,351.56l.12.11c.07.08,0,.2-.12.12l-.12-.11C61.9,351.6,62,351.48,62.1,351.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.13,349.25a40.7,40.7,0,0,0,8.64,20.27,21.58,21.58,0,0,0,7,5.47c3,1.5,6.22,3.23,9.35,4.46a61.28,61.28,0,0,1,3.32,11.76l.3-1c-2-17.31-13.22-32.11-27.55-41.6A.69.69,0,0,0,39.13,349.25Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.08,354.36c-.1-.09,0-.27.14-.19a58.7,58.7,0,0,1,18.26,22.5c.1.24-.22.45-.36.21-.66-1.17-1.34-2.3-2-3.42,0,0,0,0,0,0-3.27-.61-6.37-2.91-8.8-5.1-.06-.06,0-.15.1-.09a20.54,20.54,0,0,0,4.14,2.9c1.33.68,2.77,1.11,4.15,1.65-1.21-1.93-2.47-3.77-3.79-5.56a38.33,38.33,0,0,1-9.83-5.52c-.09-.07,0-.23.09-.16a99.15,99.15,0,0,0,9.14,4.88,83.17,83.17,0,0,0-6.45-7.52c-1.11-.59-2.24-1.18-3.32-1.8a.09.09,0,0,1,.07-.17,11.57,11.57,0,0,1,2.55,1.25C46.83,356.91,45.5,355.62,44.08,354.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,360.34a3.63,3.63,0,0,1,.55.39.06.06,0,0,1-.07.09,4,4,0,0,1-.57-.32C44.19,360.43,44.28,360.27,44.38,360.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.1 428.7 50.84 428.7 54.01 392.94 54.7 385.06 86.23 385.06 86.93 392.94 90.1 428.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.93 392.94 54.01 392.94 54.7 385.06 86.23 385.06 86.93 392.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.82,
    y: 379.55,
    width: 35.29,
    height: 7.8,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.13,454.25c2.4.76,72.67-.76,75.24-2.48,1-.63-5-67.19-5-67.19l-44.57.85L359.84,430s-25.93,12.29-28.56,14.47S326.72,453.51,329.13,454.25Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,454.25c2.41.75,72.69-.77,75.25-2.48.31-.19.4-6.95-.72-15.75-12.74,2.13-58.22,9.12-61.76,7-2.47-1.45-.29-3.72,1.74-5.24-5.81,2.89-11.23,5.68-12.35,6.61C328.68,446.59,326.72,453.51,329.12,454.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,419.28l49.75-.62S393.66,313.87,394,311.86c.46-2.58,31.5-124.3,31.5-124.3H383.77S350.84,301,349.66,311.94C347.75,329.59,355.58,419.28,355.58,419.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4,408.79c-2.58-.19-5.2-.16-7.79-.19s-5.19-.05-7.78,0c-5.19.05-10.38.13-15.57.28-1.42,0-2.83.08-4.25.15s-3,.32-4.55.38a.09.09,0,0,0,0,.18c1.27,0,2.55.21,3.82.24s2.65.05,4,.05c2.59,0,5.19,0,7.78,0,5.19,0,10.38-.11,15.56-.33,2.93-.12,5.89-.15,8.81-.45A.13.13,0,0,0,398.4,408.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.75,196.94c-3.28,13.36-6.23,26.81-9.11,40.26s-5.75,26.9-8.61,40.36q-2.14,10.08-4.28,20.18c-1.39,6.55-3,13.14-3.21,19.87s.94,13.68,1.75,20.46,1.62,13.61,2.45,20.42c1.67,13.61,3.3,27.24,5.25,40.82q.38,2.55.72,5.1c0,.14.25.13.23,0-1.38-13.64-2.79-27.26-4.36-40.88q-1.17-10.22-2.38-20.43c-.8-6.79-1.83-13.6-2.28-20.43s.58-13.54,2-20.26,2.82-13.17,4.23-19.75q4.3-20.19,8.6-40.37c3.19-15.06,6.37-30.16,9.11-45.31A.06.06,0,1,0,412.75,196.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.53,187.56s-13.32,52.22-22.64,89l-17.76-89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.67,454.42c2.4.75,72.68-.77,75.24-2.48,1-.64-2.68-67.24-2.68-67.24l-44,.85,2.13,44.57s-25.93,12.28-28.56,14.46S378.26,453.67,380.67,454.42Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.67,454.42c2.4.74,72.68-.77,75.24-2.49.31-.19.24-6.77,0-15.76-12.74,2.14-58.93,9.13-62.47,7.05-2.47-1.46-.29-3.72,1.74-5.25-5.81,2.89-11.23,5.68-12.35,6.61C380.22,446.75,378.26,453.68,380.67,454.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,187.54s1.21,20,6,35.73c.38,1.31.8,2.59,1.24,3.82a74.62,74.62,0,0,1,12.12,6s3,76.38,3,81.12c-.2,17.74,2.34,104.16,2.34,104.16l49.11-.42s-7.57-97.72-7.59-104.22-6.12-86.25-6.12-86.25c6.66-17.18-3.13-39.95-3.13-39.95Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,216.25c-.17-1.17-.35-2.33-.53-3.49-.32-2.13-.76-4.25-1.13-6.37-.85-4.82-1.73-9.65-2.8-14.42a.11.11,0,0,0-.21,0c.19,1.92.41,3.85.69,5.76s.46,3.85.73,5.77c.54,3.8,1.07,7.61,1.71,11.4.25,1.46,1.16,4.07-.94,4.53-1.66.35-2.88-1.28-3.37-2.65a32.27,32.27,0,0,1-1.12-5.25q-.51-2.88-.91-5.78c-.6-4.21-1.25-8.39-1.93-12.59,0-.12-.21-.08-.21,0a126.12,126.12,0,0,0,.93,12.88q.4,3.07.92,6.12a21.81,21.81,0,0,0,1.41,5.71,4.63,4.63,0,0,0,3.47,2.79h.1a.17.17,0,0,0-.06.12c0,.68,0,1.37.08,2s.21,1.35.34,2a12.51,12.51,0,0,0,.52,2,8,8,0,0,0,.37.92c.15.31.59,1.59.78,1.88.07.12.21,0,.22-.07s-.25-1.82-.28-2-.12-.66-.2-1c-.14-.65-.32-1.29-.49-1.93s-.31-1.29-.48-1.93-.38-1.31-.54-2a.07.07,0,0,0,0-.06,3,3,0,0,0,2.93-1.84A5.32,5.32,0,0,0,399,216.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,234.64a34.94,34.94,0,0,0-4.15-2.73,38.5,38.5,0,0,0-4.73-2.45c-3.19-1.39-6.48-2.34-9.77-3.43-.1,0-.17.14-.07.17,3.19,1.27,6.25,3,9.33,4.47,1.52.74,3.05,1.44,4.6,2.13s3.09,1.48,4.67,2.06A.13.13,0,0,0,407.09,234.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,206.83a27.18,27.18,0,0,1-6.65-.9c-1-.25-2-.57-3-.9a7.81,7.81,0,0,1-2.69-1.34c-1.51-1.31-2.21-3.36-2.87-5.18a49.26,49.26,0,0,1-1.74-6.29.09.09,0,0,0-.18,0,24.64,24.64,0,0,0,.9,7.14c.54,2,1.27,4.17,2.87,5.55a11.28,11.28,0,0,0,6.09,2.23,27.93,27.93,0,0,0,7.25-.1A.12.12,0,0,0,432,206.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.5,364.26c-.75-13.95-1.57-27.89-2.37-41.83-1.61-27.74-3.17-55.49-4.91-83.23q-.47-7.38-.94-14.76A48.86,48.86,0,0,0,436,192.27c-.06-.15-.31-.15-.25,0a55.28,55.28,0,0,1,1.49,32.12c.91,17.19,1.93,34.37,2.93,51.55q2.4,41.63,5,83.22c1,15.65,2.22,31.29,3.21,46.94,0,.11.19.11.18,0C447.79,392.16,447.25,378.2,446.5,364.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,409.43c-2.58-.18-5.19-.15-7.78-.19s-5.19,0-7.79,0c-5.19,0-10.38.13-15.56.27l-4.26.15c-1.52.07-3,.33-4.54.39a.09.09,0,0,0,0,.18c1.28,0,2.55.2,3.83.24s2.64.05,4,.05c2.6,0,5.19,0,7.79,0,5.18-.05,10.38-.12,15.56-.33,2.93-.12,5.89-.16,8.8-.45A.14.14,0,0,0,453,409.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,118.43c1.65-2.74,3.4-5.43,4.85-8.29a48.28,48.28,0,0,0,3.45-9c.18-.67.36-1.35.52-2a57.31,57.31,0,0,1,2.09-11.35c2.55-7.57,7.2-14,15.66-14.49,4-.25,7.58,1.09,7.45,1.21,5.47.67,10.83,3,13.59,8,2.21,3.94,2.44,8.6,3.35,12.93a102.69,102.69,0,0,0,4.26,13.93c1.19,3.25,2.41,6.5,3.48,9.79l.64,1.27a45.46,45.46,0,0,1,3.81,9.71,28.56,28.56,0,0,1-2,19.67,25.17,25.17,0,0,1-6.64,8.11s-.08,0-.05,0a25.9,25.9,0,0,0,8.81-16.26,30.18,30.18,0,0,0-.45-10.8,41.94,41.94,0,0,0-3.27-8.93,53.66,53.66,0,0,1,2.37,13.63c.22,8-2.14,16.14-8.37,21.54a31.4,31.4,0,0,1-21.4,7.76c-8.94-.41-33.55-2.2-34.67-24.16-.34-6.76,1.45-13.15,3.69-19-.73,1.4-1.44,2.82-2,4.3a32.84,32.84,0,0,0-2.44,10.22,24.69,24.69,0,0,0,2.14,11.68c0,.08-.07.14-.11.07-3.23-6-2.9-13.39-.87-19.69a59.18,59.18,0,0,1,4.38-9.59c.34-.64.66-1.29,1-2,.83-1.93,1.65-3.78,2.39-5.55.41-1.06.81-2.13,1.21-3.2s.68-1.91,1-2.88a20.08,20.08,0,0,0,.55-2.44c.05-.31.09-.62.14-.94a45.9,45.9,0,0,1-2.25,6.47c-2.54,5.83-6.56,10.83-9.27,16.57a25.25,25.25,0,0,0-2.63,10.6.08.08,0,1,1-.15,0C368.88,129.23,371.89,123.52,375,118.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,127.05c-6.69,12-34,40.52-47.87,40.51-11.11,0-39.22-8.43-47.68-13.25-2.33-1.33,9.21-28.87,12.25-28.22,7.16,1.52,28.09,14.51,34.69,13.59,2.6-.36,19.38-9.3,39.56-20.26C409.79,115.17,415,119.86,411,127.05Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.53,156c-3.42-1.23-18.6-8.26-22.38-11.16s-14.08-12-12.15-15.16,5.15-.69,5.15-.69-3.74-4.55-1.51-7.52,7.12,1,7.12,1-3.49-4.94-1.06-7.75,6.69,2,6.69,2-3.41-4.38-.43-5.84c3.58-1.77,9,7,13.37,9.9,1,.65,21.29,11.84,21.29,11.84Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,116.3c4,6.45,6.81,8.58,13.49,11.86.13.07.07.28-.07.22-6.84-2.62-10.8-4.78-13.75-11.9C300.55,116.13,300.83,116,301,116.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46,122c4.7,6.33,7.77,8.67,14.52,12.62.09.06,0,.23-.09.18-6.95-3.32-10.85-5.57-14.72-12.52C295,121.92,295.24,121.66,295.46,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.5,129.19c5,5.8,8.25,8.51,15.29,11.51a.14.14,0,0,1-.09.26c-7.48-2.35-11.57-5.71-15.36-11.6C290.08,129,290.18,128.82,290.5,129.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,134.63s-3.39-8.85-5.74-12.42-16-13.61-18.31-10.79c-3,3.64,3.71,11,7.47,14.17,0,0-7,8.41-3.31,14.74S339.93,134.63,339.93,134.63Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38,112.69c-.36,5.31,4.85,9.15,8.27,12.5a.44.44,0,0,1-.09.72c-2.69,3.72-5.41,9.76-3.81,14.34a.11.11,0,0,1-.2.09c-2.38-4.68-.2-10.83,3-14.72-3.57-3.38-8.62-7.46-7.24-12.93A0,0,0,0,1,315.38,112.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,128.49,331.2,166s22.84,4.19,33.88,2.77,35.64-24.21,43.73-35.25,7.47-22.39-9.55-13.93-36.41,18.88-37,19.05S339,128.49,339,128.49Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.4,149.36c.58-2.68,2.73-13.38,3-16.05,0-.08-.1-.08-.12,0-.82,2.6-3.2,13.32-3.77,16-1.13,5.36-2.33,10.75-3.07,16.17,0,.11.12.15.15,0C340.16,160.21,341.25,154.76,342.4,149.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05,168.14c6.61.75,14,1.26,19,.61,11-1.43,35.64-24.2,43.73-35.25,6.91-9.43,7.47-19.09-3.12-16.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,150.07a.38.38,0,0,0,0-.1l0-.12-.08-.12a.91.91,0,0,0-.73-.37.9.9,0,1,0,.73,1.41.75.75,0,0,0,.07-.12.16.16,0,0,0,0-.07.83.83,0,0,0,0-.15.82.82,0,0,0,0-.36Zm13-.71a.9.9,0,1,0,.9.89A.89.89,0,0,0,353.53,149.36Zm27.74-20.19a.9.9,0,1,0,.89.89A.89.89,0,0,0,381.27,129.17ZM367.4,149.36a.9.9,0,1,0,.89.89A.89.89,0,0,0,367.4,149.36Zm-27.74-20.19a.9.9,0,1,0,.9.89A.89.89,0,0,0,339.66,129.17Zm6.94,10.07a.9.9,0,1,0,.89.89A.89.89,0,0,0,346.6,139.24Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,360.47,139.24Zm-27.74,20.19-.17,0-.34,1.61a.88.88,0,0,0,.51.16.9.9,0,0,0,0-1.79Zm7.81-9.36a.38.38,0,0,0,0-.1l0-.12-.08-.12v1a.75.75,0,0,0,.07-.12.16.16,0,0,0,0-.07.83.83,0,0,0,0-.15.82.82,0,0,0,0-.36Zm13-.71a.9.9,0,1,0,.9.89A.89.89,0,0,0,353.53,149.36Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,367.4,149.36Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,381.27,149.36ZM346.6,159.43a.9.9,0,1,0,.89.89A.89.89,0,0,0,346.6,159.43Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,360.47,159.43Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,374.34,159.43Zm20.8-30.26a.9.9,0,1,0,.89.89A.89.89,0,0,0,395.14,129.17Zm13.87,0a.9.9,0,1,0,.89.89A.89.89,0,0,0,409,129.17ZM388.2,139.24a.9.9,0,1,0,.9.89A.89.89,0,0,0,388.2,139.24Zm13.87,0a.9.9,0,0,0,0,1.79.87.87,0,0,0,.59-.23.26.26,0,0,0,.09-.09v0a.85.85,0,0,0,.2-.56A.89.89,0,0,0,402.07,139.24Zm0-20.19a.9.9,0,1,0,.89.9A.89.89,0,0,0,402.07,119.05Zm-27.74,20.19a.9.9,0,1,0,.9.89A.89.89,0,0,0,374.33,139.24Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.39,162.51l-4.12,29.84s4.73,0,11.6.06l3.3-6,4.63,6.06c14.94,0,34.14-.1,41.11-.64,0,0-10.24-55.65-23.31-69.63-6.54-7-14.15-6.42-19-1.46-1.22,1.26-15.73,20.72-17.22,28.13C382.12,155.36,386.39,162.51,386.39,162.51Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.9,191.78c-7,.54-26.16.65-41.1.64l-4.63-6.06-3.3,6c-6.87,0-11.6-.06-11.6-.06l4.12-29.84s-4.27-7.15-3-13.69c.81-4,5.54-11.74,9.85-18.07.07-.08.12-.17.18-.25,3.48-5.1,6.64-9.25,7.19-9.81,4.63-4.77,11.84-5.49,18.18.67a0,0,0,0,1,0,0,.83.83,0,0,1,.17.15c.2.2.41.41.6.62a35.2,35.2,0,0,1,5.13,7.73l.23.43a145.41,145.41,0,0,1,8.62,22.84c0,.1.06.2.1.29C439.32,172.26,442.9,191.78,442.9,191.78Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94,119.05a.89.89,0,1,1-.89.89A.89.89,0,0,1,415.94,119.05Zm-14.74,1.09a.89.89,0,0,0,1.76-.2.9.9,0,0,0-.52-.81A13,13,0,0,0,401.2,120.14Zm27.71,20a.89.89,0,0,0,.63.85c-.17-.44-.34-.88-.5-1.32A1,1,0,0,0,428.91,140.13Zm-13.86,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,140.13Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,401.18,140.13Zm-13.87,0h0a.89.89,0,1,0,.89-.9.83.83,0,0,0-.44.12ZM422,130.06a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,130.06Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,408.11,130.06Zm-13.87,0a.9.9,0,1,0,.9-.89A.89.89,0,0,0,394.24,130.06Zm34.68,30.26a.89.89,0,1,0,.89-.89A.89.89,0,0,0,428.92,160.32Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,160.32Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,401.18,160.32Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,387.31,160.32ZM422,150.25a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,150.25Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,408.11,150.25Zm-13.87,0a.9.9,0,1,0,.9-.89A.89.89,0,0,0,394.24,150.25Zm34.68,30.26a.89.89,0,1,0,.89-.89A.89.89,0,0,0,428.92,180.51Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,180.51Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,401.18,180.51Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,387.31,180.51Zm48.54-10.07a.89.89,0,1,0,.89-.89A.89.89,0,0,0,435.85,170.44Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,170.44Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,408.11,170.44Zm-13.87,0a.9.9,0,1,0,.9-.89A.89.89,0,0,0,394.24,170.44Zm41.61,20.19a.89.89,0,1,0,.89-.89A.89.89,0,0,0,435.85,190.63Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,190.63Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,408.11,190.63Zm-13.87,0a.88.88,0,0,0,.26.63l.81-1.5-.18,0A.89.89,0,0,0,394.24,190.63Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.23,178.41c.52-2.73.91-4.87,1.35-7.61s.9-5.47,1.3-8.22l0-.18-.11-.17a20.69,20.69,0,0,1-2.8-6.9,14.89,14.89,0,0,1-.35-3.7,12.59,12.59,0,0,1,.56-3.66,43.24,43.24,0,0,1,3-7c1.18-2.27,2.15-4.17,3.47-6.38.22-.34.08-.42-.12-.15-1.32,1.81-2.77,4.29-3.9,6.23a38.65,38.65,0,0,0-3.36,7,13,13,0,0,0-.69,3.91,16.88,16.88,0,0,0,.34,4A20.61,20.61,0,0,0,386,162.8l-.09-.35c-.36,2.75-.66,5.5-1,8.26-.29,2.48-.61,5.15-.83,7.64C384.08,178.63,384.06,179.41,384.23,178.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.29,136.67a11.83,11.83,0,0,0-1.33,2.57,11.07,11.07,0,0,0-.44,1.38,5.85,5.85,0,0,0-.22,1.45c.43-.88.82-1.74,1.16-2.64A16,16,0,0,0,388.29,136.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,124.31c-1.44,3.26-2.85,6.55-4.16,9.87s-2.58,6.66-3.62,10.06-2,6.9-1.19,10.36a24.46,24.46,0,0,0,1.6,5,31.18,31.18,0,0,0,2.47,4.68l.07.11v.12c-.38,3.42-.76,6.85-1.19,10.26s-.85,6.84-1.33,10.25q.38-5.16.84-10.3c.3-3.43.64-6.86,1-10.28l.06.23a27.86,27.86,0,0,1-4.19-9.95,14.48,14.48,0,0,1-.06-5.45,42.3,42.3,0,0,1,1.37-5.23c1.11-3.41,2.44-6.73,3.83-10S402.55,127.5,404.15,124.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,139a1,1,0,0,0,1.9.27,1,1,0,0,0-1.9-.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.41,148.23a1,1,0,1,0,1.08-.81A1,1,0,0,0,397.41,148.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.39,158.6a1,1,0,1,0,1.08-.81A1,1,0,0,0,398.39,158.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,168.79a1,1,0,1,0,1.08-.82A1,1,0,0,0,401.25,168.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.26,178.59a1,1,0,1,0,1.08-.82A1,1,0,0,0,400.26,178.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15,161.67a53,53,0,0,0-7.87.18c-1.3.14-2.58.34-3.86.57-.65.12-1.29.21-1.93.3a8.14,8.14,0,0,1-2,.1c-.06,0-.07.08,0,.09a13.46,13.46,0,0,0,1.91.23,13,13,0,0,0,1.87-.08c1.31-.14,2.62-.33,3.94-.48,2.66-.29,5.31-.59,8-.69C404.27,161.88,404.27,161.67,404.15,161.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.22,164.87a57.42,57.42,0,0,0-6.38-1.22c-1.07-.14-2.15-.21-3.23-.26-.52,0-1,0-1.55,0s-1.14.06-1.71,0c-.06,0-.07.09,0,.09.53,0,1.07.15,1.6.22l1.61.18,3.22.38c2.15.23,4.29.48,6.43.78C410.32,165.06,410.33,164.89,410.22,164.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.47,191v46.22H341.22V191a6.05,6.05,0,0,0-6.05-6h47.25A6.05,6.05,0,0,1,388.47,191Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,191v66.22L354,237.56l23.63,19.7V191a6.05,6.05,0,0,1,6.05-6H336.38A6.05,6.05,0,0,0,330.33,191Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,191v66.22L354,237.56l23.63,19.7V191a6.05,6.05,0,0,1,6.05-6H336.38A6.05,6.05,0,0,0,330.33,191Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.33,191v66.22L354,237.56l23.63,19.7V191a6.05,6.05,0,0,1,6.05-6H336.38A6.05,6.05,0,0,0,330.33,191Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.86 207 350.47 212.25 344.43 213.85 348.38 218.69 348.03 224.93 353.86 222.66 359.68 224.93 359.33 218.69 363.29 213.85 357.24 212.25 353.86 207",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.14,124.39c11.17,15.1,32.47,50.84,25.32,58.72-11.76,12.94-40,24.11-48.75,26.23-3.83.92-16.62-26.71-13-28.88,4.34-2.6,34.63-11.86,34.54-14.44,0-1.46-3.19-13.72-5.79-29.45C410.43,118.33,415.82,117.19,421.14,124.39Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,178.88s-11.41-3.65-19-5.69c-4.23-1.14-11.65-2.45-15.14-1.86-5.21.87-26.47,7.85-24.89,13,1.44,4.7,18.94-3.62,18.94-3.62s-18.41,6.84-15.64,12.18,21.29-6.69,21.29-6.69-18.75,7.44-15,12.5c2.81,3.82,20.2-6.13,20.2-6.13s-16.07,6.51-13.34,10.57c3,4.48,19.63-3.7,19.63-3.7,8.66,9.14,16.48,10.32,22.18,9.86C399.08,209.23,398.49,178.88,398.49,178.88Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.63,178c-2.19.73-4.41,1.45-6.53,2.36s-4.21,1.91-6.23,3a39,39,0,0,0-7.47,5.07c4.32-3.2,11.85-6.6,14-7.52s4.18-1.93,6.3-2.85C364.72,178,364.68,178,364.63,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.08,185.57c-3.27.79-9.46,3.3-16,7-.19.11-.07.18.13.08,2.66-1.24,13.54-5.76,15.92-7C368.15,185.62,368.12,185.56,368.08,185.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.21,191.56a50.05,50.05,0,0,0-11.63,5.32c-.2.11,0,.19.18.09,3.77-1.77,6.43-2.83,11.5-5.27C372.33,191.67,372.3,191.53,372.21,191.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.84,175.85l16.28,36.47s31.31-19.63,37-30.31c5.1-9.6-19.35-48.7-25-56.32s-11.32-8.92-10.69,3.83,5.9,35.87,5.9,36.23S394.84,175.85,394.84,175.85Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.81,120.12a.89.89,0,0,1-1.76-.07A2.82,2.82,0,0,1,416.81,120.12Zm12.11,20a.89.89,0,0,0,1.78,0,.89.89,0,0,0-1.78,0Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,140.13ZM422,130.06a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,130.06Zm20.8,30.26a.88.88,0,0,0,.8.88l-.64-1.39A.91.91,0,0,0,442.78,160.32Zm-13.86,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,428.92,160.32Zm6.93-10.07a.89.89,0,1,0,.89-.89A.89.89,0,0,0,435.85,150.25Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,150.25Zm20.8,30.26a.9.9,0,1,0,.9-.89A.89.89,0,0,0,442.78,180.51Zm-13.86,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,428.92,180.51Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,180.51Zm-13.87,0a.89.89,0,1,0,.89-.89A.89.89,0,0,0,401.18,180.51Zm34.67-10.07a.89.89,0,1,0,.89-.89A.89.89,0,0,0,435.85,170.44Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,170.44Zm-13.87,0a.89.89,0,1,0,1.38-.74l-1.36.58A.44.44,0,0,0,408.11,170.44Zm6.94,30.26a.89.89,0,1,0,.89-.89A.89.89,0,0,0,415.05,200.7Zm20.8-10.07a.89.89,0,1,0,.89-.89A.89.89,0,0,0,435.85,190.63Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,422,190.63Zm-13.87,0a.9.9,0,1,0,.89-.89A.89.89,0,0,0,408.11,190.63Z",
    style: {
      fill: "#020100",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.06,190.06c-1.19-2.76-6.06-13.71-7.52-16.28,0-.08-.15,0-.13.07.89,2.86,5.54,14,6.74,16.74,2.39,5.52,4.73,11.11,7.55,16.42a.1.1,0,0,0,.18-.07C414.94,201.2,412.45,195.63,410.06,190.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.78,151.59c-.92-4.84-1.73-9.71-2.56-14.58,0-.09-.17-.07-.17,0,.23,2.75.56,5.49.95,8.21-.45-1.4-.85-2.82-1.24-4.25,0-.11-.18-.06-.16.05a28.38,28.38,0,0,0,1.59,5.5c.25,1.66.51,3.31.81,5,.43,2.41,2.59,13,2.91,14.2-4.08,1.4-7.68,3.13-11.68,4.77-2,.8-3.9,1.61-5.83,2.46a51.35,51.35,0,0,0-5.94,2.57c-.11.06.25.57.38.82s.24.1.2,0-.08-.25-.1-.35c1-.26,4.84-1.9,5.84-2.3l5.85-2.4c4-1.63,12.18-5,12.18-5.07C418.7,165.06,416.25,154.05,415.78,151.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.36,120.15c-.31,1.14-6.06,8.41-11.31,8-1.71-.14-1.34-9.51-1.34-9.51l-.13-.69-1.83-9.77,11.64-6.9,1.68-.91s.32,2.71.69,6.08c0,.16,0,.31.05.48a5.52,5.52,0,0,1,.07.55c.06.5.12,1,.17,1.53s.08.77.11,1.18.06.81.1,1.22A62.87,62.87,0,0,1,412.36,120.15Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.76,106.43a20,20,0,0,1-12.18,11.5l-1.83-9.77,11.64-6.9,1.68-.91S411.39,103.06,411.76,106.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.77,90.34c-5.56,16.53,3.71,21.72,7.28,22.91,3.23,1.08,14.39,4.36,21.62-11.5s1.3-23.67-6-26.54S391.32,73.82,385.77,90.34Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.05,88.27c.41.08.8.08,1.2.12a2,2,0,0,0,1.25-.12.63.63,0,0,0,.22-.72,1.54,1.54,0,0,0-1.34-.8,2.28,2.28,0,0,0-1.59.34A.66.66,0,0,0,389.05,88.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.48,91.79a9.69,9.69,0,0,1-1.05-.58,2,2,0,0,1-1-.81.6.6,0,0,1,.23-.72,1.52,1.52,0,0,1,1.55.11A2.26,2.26,0,0,1,401.37,91,.66.66,0,0,1,400.48,91.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.57,95.06s.07.08.05.13c-.41,1.11-.7,2.45.19,3.17,0,0,0,.08,0,.06C395.6,97.82,396,96,396.57,95.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,94.22c1.85.47.77,4.15-1,3.71S396.41,93.82,398,94.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.63,94.63c.26.3.47.76.84.91s.89-.11,1.29-.39c0,0,.07,0,.05.06-.19.71-.68,1.35-1.46,1.23s-1-.87-1-1.63C398.36,94.67,398.53,94.51,398.63,94.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,93s-.11,0-.12.08c-.29,1.15-.81,2.42-1.95,2.5,0,0-.05.06,0,.07C389.54,95.78,390.22,94.09,390.31,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,91.47c-1.79-.66-3,3-1.33,3.59S391.14,92,389.63,91.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.79,91.46c-.35.1-.75.36-1.1.26s-.57-.59-.7-1c0,0-.05,0-.07,0-.25.69-.26,1.49.37,1.84s1.21-.13,1.61-.76C389,91.65,388.94,91.42,388.79,91.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,104.44c-.35.2-.71.51-1.14.44a3.31,3.31,0,0,1-1.17-.59,0,0,0,0,0-.06,0,1.6,1.6,0,0,0,1.31,1,1.26,1.26,0,0,0,1.15-.8C394.08,104.46,394,104.41,394,104.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.46,98.88s-.75,1.63-1,2.42c0,.08.16.17.43.27,0,0,0,0,0,0a4,4,0,0,0,4.13-.28c.08-.06,0-.18-.09-.15a6,6,0,0,1-3.77-.07c0-.24,1.38-2.74,1.26-2.78a7,7,0,0,0-1.94-.15c1.47-3.43,3.48-6.59,4.9-10,0-.12-.12-.22-.19-.12a59.85,59.85,0,0,0-5.74,10.57C388.27,99,390.1,98.92,390.46,98.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,101.54a4.18,4.18,0,0,0,1.16,1.73,1.89,1.89,0,0,0,1,.42c.84,0,1.09-.65,1.15-1.3a4.36,4.36,0,0,0,0-1A5.29,5.29,0,0,1,390.53,101.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.69,103.27a1.89,1.89,0,0,0,1,.42c.84,0,1.09-.65,1.15-1.3A1.91,1.91,0,0,0,391.69,103.27Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2,102c-3.24-.46-2.08-7.86-2.08-7.86s-12.72-5.91-10.88-17.08a19,19,0,0,1-12,7.51s3.72-11.78,13.8-11.5c0,0,12.88-1.06,16.92,10S415.37,102.34,413.2,102Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.42,76.27a12.19,12.19,0,0,0-.76,5.12A12.7,12.7,0,0,0,401,86.47a11,11,0,0,0,.66,1.15l.34.56c.13.18.26.35.4.52.28.34.55.69.84,1s.63.61,1,.91c.16.14.31.3.48.44l.52.39,1,.77c.75.44,1.51.85,2.28,1.24-.68-.54-1.39-1-2.05-1.55l-1-.84-.47-.42c-.15-.15-.29-.31-.43-.47-.28-.31-.57-.62-.86-.92s-.5-.68-.75-1l-.38-.5-.31-.54a11.81,11.81,0,0,1-.61-1.1,14.68,14.68,0,0,1-1.42-4.78,15.22,15.22,0,0,1-.11-2.53A15.67,15.67,0,0,1,400.42,76.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.65,107.85a3.32,3.32,0,0,1-.83,0,2.53,2.53,0,0,1-.81-.17,2.59,2.59,0,0,1-.9-.55,3.09,3.09,0,0,1-.52-.65,3.49,3.49,0,0,1-.41-1.11l2-4.3s5-4.39,7-2.49S415.72,107.49,412.65,107.85Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.9,100.56c.05,0,0,.08,0,.08-2.17.32-3.66,1.9-4.84,3.63a1.62,1.62,0,0,1,2.47.14s0,.11-.08.09a1.82,1.82,0,0,0-2.09.14,9.29,9.29,0,0,0-1.31,1.35c-.14.15-.43,0-.31-.21l0,0C411.32,103.21,414.13,100.16,416.9,100.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,107.08a.81.81,0,1,1-.39-1.07A.81.81,0,0,1,412.59,107.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.49,106.29a.57.57,0,0,1-1-.48.58.58,0,0,1,.76-.28A.57.57,0,0,1,414.49,106.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.6,119.35l2.86,8.21,10.05-10.29,3.13,4s-10.56,15.74-10.59,15l-3-7.11-5,4.61,1-12.12Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,127.73c.22-2,.39-4,.71-6,0-.07.12-.1.14,0,.31,2-.6,9.57-.67,11.41l0,0c.21-.2,4.64-4,4.68-4,.67,1.14,2.87,6.31,3,6.78,1.67-2.5,8.72-12.34,10.67-14.69a.07.07,0,0,1,.12.08c-1.5,2.65-10.63,15.64-10.75,15.6A77.68,77.68,0,0,1,402,129.4c-.76.85-5.26,5.21-5.26,4.92A60.43,60.43,0,0,1,397.17,127.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.99,
    y: 422.22,
    width: 87.82,
    height: 30.58,
    transform: "translate(359.81 875.03) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: 422.22,
    width: 37.89,
    height: 30.58,
    transform: "translate(234.09 875.03) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.99,
    y: 425.4,
    width: 87.82,
    height: 24.23,
    transform: "translate(359.81 875.03) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,444.64q-10.26.19-20.53.26l-20.54.08-20.53-.08q-10.28-.06-20.54-.26,10.27-.18,20.54-.26l20.53-.08,20.54.08Q207.86,444.46,218.13,444.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,439.89q-10.26.18-20.53.26l-20.54.08-20.53-.08q-10.28-.06-20.54-.26,10.27-.19,20.54-.26l20.53-.08,20.54.08Q207.86,439.69,218.13,439.89Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,435.14q-10.26.18-20.53.26l-20.54.08-20.53-.08q-10.28-.07-20.54-.26,10.27-.19,20.54-.27l20.53-.07,20.54.08Q207.86,434.94,218.13,435.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.13,430.38q-10.26.19-20.53.26l-20.54.08-20.53-.08q-10.28-.06-20.54-.26,10.27-.18,20.54-.26l20.53-.08,20.54.08Q207.86,430.2,218.13,430.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.15,432.22v22.39l-8-6.66-8,6.66V432.22a2,2,0,0,0-2-2.05h16A2,2,0,0,1,199.15,432.22Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.15,432.22v22.39l-8-6.66-8,6.66V432.22a2,2,0,0,0-2-2.05h16A2,2,0,0,1,199.15,432.22Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.76,
    y: 399.98,
    width: 87.9,
    height: 22.25,
    transform: "translate(379.43 822.2) rotate(180)",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.35,
    y: 399.98,
    width: 72.42,
    height: 22.25,
    transform: "translate(219.11 822.2) rotate(180)",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.76,
    y: 402.28,
    width: 87.9,
    height: 17.63,
    transform: "translate(379.43 822.2) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,416.29q-10.29.18-20.56.26l-20.55.08-20.55-.08q-10.27-.07-20.56-.26,10.29-.19,20.56-.26l20.55-.08,20.55.08Q217.7,416.09,228,416.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,412.83q-10.29.18-20.56.26l-20.55.08-20.55-.08q-10.27-.06-20.56-.26,10.29-.19,20.56-.26l20.55-.08,20.55.08Q217.7,412.63,228,412.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,409.37q-10.29.19-20.56.26l-20.55.08-20.55-.08q-10.27-.06-20.56-.26,10.29-.19,20.56-.26l20.55-.08,20.55.08Q217.7,409.19,228,409.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,405.91q-10.29.19-20.56.26l-20.55.08-20.55-.08q-10.27-.06-20.56-.26,10.29-.18,20.56-.26l20.55-.08,20.55.08Q217.7,405.73,228,405.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,411.42v22.39l-8-6.66-8,6.66V411.42a2.05,2.05,0,0,0-2.05-2.05h16A2.05,2.05,0,0,1,219,411.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,411.42v22.39l-8-6.66-8,6.66V411.42a2.05,2.05,0,0,0-2.05-2.05h16A2.05,2.05,0,0,1,219,411.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.95,
    y: 377.66,
    width: 79.77,
    height: 22.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.72,
    y: 377.66,
    width: 45.23,
    height: 22.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.95,
    y: 379.96,
    width: 79.77,
    height: 17.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,383.59q9.31-.18,18.65-.26l18.65-.08,18.65.08q9.33.07,18.65.26-9.33.2-18.65.26l-18.65.08-18.65-.08Q112.44,383.79,103.12,383.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,387.05q9.31-.18,18.65-.26l18.65-.08,18.65.08q9.33.06,18.65.26-9.33.19-18.65.26l-18.65.08-18.65-.08C115.55,387.27,109.33,387.17,103.12,387.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,390.51q9.31-.19,18.65-.26l18.65-.08,18.65.08q9.33.06,18.65.26-9.33.18-18.65.26l-18.65.08-18.65-.08Q112.44,390.7,103.12,390.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,394q9.31-.2,18.65-.26l18.65-.08,18.65.08q9.33.06,18.65.26-9.33.18-18.65.26l-18.65.08-18.65-.08Q112.44,394.16,103.12,394Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,392.56V415l8-6.66,8,6.66V392.56a2.05,2.05,0,0,1,2.05-2.05h-16A2.05,2.05,0,0,0,113.05,392.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bookmark--inject-105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.91,53.81h.85a5.52,5.52,0,0,1,5.52,5.52v1.91a0,0,0,0,1,0,0H282.39a0,0,0,0,1,0,0V59.33A5.52,5.52,0,0,1,287.91,53.81Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.91,53.81h.85a5.52,5.52,0,0,1,5.52,5.52v1.91a0,0,0,0,1,0,0H282.39a0,0,0,0,1,0,0V59.33A5.52,5.52,0,0,1,287.91,53.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.67,59.84v66.22l-23.62-19.7-23.63,19.7V59.84a6.05,6.05,0,0,0-6.05-6.05h47.25A6.05,6.05,0,0,1,340.67,59.84Z",
    style: {
      fill: "#EA8D0C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.15 75.79 320.53 81.05 326.58 82.64 322.62 87.48 322.98 93.73 317.15 91.46 311.32 93.73 311.68 87.48 307.72 82.64 313.77 81.05 317.15 75.79",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksCuate);
export default __webpack_public_path__ + "static/media/Bookmarks-cuate.fc22c7df1009cd1cf84dab0c20f581e1.svg";
export { ForwardRef as ReactComponent };